import WasmController from "react-lib/frameworks/WasmController";

// Utils
import {
  beDateStr,
  beMoment,
  beNowDateStr,
  beNowTimeStr,
  beStampStr,
  beTimeStr,
  convertBEDateToADDashDate,
  dateToStringWithoutTimeBE,
} from "react-lib/utils/dateUtils";
import moment from "moment";

// APIS
import ChatChannelNoSubscriptionList from "issara-sdk/apis/ChatChannelNoSubscriptionList_apps_MSG";
import UserChatSubscriptionList from "issara-sdk/apis/UserChatSubscriptionList_apps_MSG";
import ChatChannelList from "issara-sdk/apis/ChatChannelList_apps_MSG";
import UserChatSubscriptionDetail from "issara-sdk/apis/UserChatSubscriptionDetail_apps_MSG";
import KickUserChatChannelDetail from "issara-sdk/apis/KickUserChatChannelDetail_apps_MSG";
import ChatChannelDetail from "issara-sdk/apis/ChatChannelDetail_apps_MSG";
import MessageSearchView from "issara-sdk/apis/MessageSearchView_apps_MSG";
import EncounterDetail from "issara-sdk/apis/EncounterDetail_core";
import PatientQueueList from "issara-sdk/apis/PatientQueueList_apps_PRX";
import PatientDetailView from "issara-sdk/apis/PatientDetailView_apps_REG";
import PatientAppointmentView from "issara-sdk/apis/PatientAppointmentView_apps_QUE";
import DiagFormList from "issara-sdk/apis/DiagFormList_apps_PRX";
import ProxyPatientDetail from "issara-sdk/apis/ProxyPatientDetail_apps_PRX";
import PatientNoteListView from "issara-sdk/apis/PatientNoteListView_apps_REG";
import PatientNoteDetailView from "issara-sdk/apis/PatientNoteDetailView_apps_REG";
import PatientAppointmentUpdate from "issara-sdk/apis/PatientAppointmentUpdate_apps_QUE";
import DiagRuleList from "issara-sdk/apis/DiagRuleList_apps_PRX";
import FormCategoryList from "issara-sdk/apis/FormCategoryList_apps_PRX";
import CheckCanUseMeHealthServiceView from "issara-sdk/apis/CheckCanUseMeHealthServiceView_apps_MEH";
import ChatbotList from "issara-sdk/apis/ChatbotList_core";
import OfficialAccountListView from "issara-sdk/apis/OfficialAccountListView_apps_PRX";
import DoctorDivisionServiceBlockSchedule from "issara-sdk/apis/DoctorDivisionServiceBlockSchedule_apps_QUE";
import DivisionServiceBlockAvailableList from "issara-sdk/apis/DivisionServiceBlockAvailableList_apps_QUEM";
import PackageOrderList from "issara-sdk/apis/PackageOrderList_core";
import PackageOrderDetail from "issara-sdk/apis/PackageOrderDetail_core";
import PackageOrderCounterPaymentView from "issara-sdk/apis/PackageOrderCounterPaymentView_apps_BIL";
import PackageTypeList from "issara-sdk/apis/PackageTypeList_core";
import PackageWithItemList from "issara-sdk/apis/PackageWithItemList_core";
import OfficialAccountDivisionDetail from "issara-sdk/apis/OfficialAccountDivisionDetail_apps_PRX";
import CONFIG from "config/config";
import PackageOrderWithItemList from "issara-sdk/apis/PackageOrderWithItemList_core";
import AppointmentPackageList from "issara-sdk/apis/AppointmentPackageList_apps_APP";
import PackageDetail from "issara-sdk/apis/PackageDetail_core";

// Serializers
import PatientAppointmentSerializer from "issara-sdk/types/PatientAppointmentSerializer_apps_QUE";
import DiagFormSerializer from "issara-sdk/types/DiagFormSerializer_apps_PRX";
import ProxyPatientSerializer from 'issara-sdk/types/ProxyPatientSerializer_apps_PRX'
import PatientNoteSerializer from "issara-sdk/types/PatientNoteSerializer_apps_REG";
import DiagRuleSerializer from "issara-sdk/types/DiagRuleSerializer_apps_PRX";
import ChatbotSerializer from "issara-sdk/types/ChatbotSerializer_core"




export type Props = {};

export type State = {
  // common state
  errorMessage?: any;
  django?: any;
  currentDoctor?: any;
  chatRoomList?: any[];
  allChatRoomList?: number[];
  allAdminChatRoomIds?: number[];
  allAdminChatRoomList?: any[];
  adminChatUnreadCount?: string;
  openPatientChatId?: number | null;
  patientHNChatList?: string[];
  userChatSubscriptionList?: any[];
  showIconNoti?: boolean;
  goToStaffChat?: boolean;
  searchMessageList?: Record<string, any>;
  modOpenLinkEncounter?: string;
  selectedPatientChat?: Record<string, any> | null;
  selectedPatientAppointmentList?: PatientAppointmentSerializer[];
  selectedPatientDiagFormList?: DiagFormSerializer[];
  selectedPatientNoteList?: PatientNoteSerializer[];
  selectedProxyPatient?: ProxyPatientSerializer;
  diagFormData: DiagFormData;
  aiBotLists?: { divisionId: number, aiLists: ChatbotSerializer[]};
  officialAccountList: Record<string, any>[];

  // --- สำหรับ BookingSection (logic ยกมาจาก ishealth-main: MobIsHealthInterface / MobIsHealthProviderInterface) ---
  createAppointment?: any;
  timeDivision?: any[];
  loadingStatus?: Record<string, any>;
  packageTypeList?: any[];
  // นัดที่เพิ่งสร้างจาก BookingSection (ใช้ refresh ฟอร์ม/แจ้งผล)
  createdAppointment?: any;

  // --- สำหรับ CartSection (display ตาม MeHealthHome ของ ishealth-main) ---
  cartData?: CartData;
};

// ข้อมูลของ tab "Cart" ใน ProfilePanel
// packageList = รายการตรวจที่เปิดขายของแผนก (กรองตามอายุ/เพศคนไข้ + keyword ถ้ามีการค้น)
// cartItems = package order ที่ staff เพิ่มให้ผู้รับบริการแล้ว และยังไม่ชำระ (in cart / BILLED_COUNTER)
export type CartData = Partial<{
  packageList: any[];
  cartItems: any[];
  cartCount: number;
  // id ของผู้รับบริการที่ cartData ชุดนี้ถูกโหลดให้ (กันข้อมูลคนเก่าค้างเมื่อสลับแชท)
  cartPatient: number;
  // ยังมีรายการของ keyword นี้อีก (API ตอบ next) → CartSection ขึ้นปุ่ม "โหลดรายการเพิ่ม"
  packageHasMore: boolean;
  // keyword ของลิสต์ที่โหลดค้างอยู่ (offset ถัดไปต้องใช้คำเดิม)
  searchKeyword: string;
}>;

export type DiagFormData = Partial<{
  searchLoading: boolean;
  activePage: number;
  items: DiagFormSerializer[];
  total: number;
  diagFormList: DiagRuleSerializer[];
}>;

export type DiagFormFilter = Partial<{
  form_type: "ALL" | "INPUT_FORM" | "DECISION_TREE";
  diag_rule: number | string;
  start_date: string; // YYYY-MM-DD (AD) Format Ex. 2025-12-19
  end_date: string; // YYYY-MM-DD (AD) Format Ex. 2025-12-20
  type?: string;
}>;

export const StateInitial: State = {
  chatRoomList: [],
  allChatRoomList: [],
  allAdminChatRoomList: [],
  searchMessageList: {},
  userChatSubscriptionList: [],
  goToStaffChat: false,
  selectedPatientChat: null,
  diagFormData: {},
};

export type Event =
  | {
      message: "GetChatChannelList";
      params: { isPatient: boolean; user: string; all?: boolean };
    }
  | {
      message: "GetUnreadMessageCountStaff";
      params: { isPatient?: boolean; user?: string; all?: boolean; isChatPatientOnly?: boolean };
    }
  | {
      message: "CreateUpdateChatRoom";
      params: { userIds: number[]; groupName: string };
    }
  | { message: "GetUserChatSubscriptionList"; params: { id: number } }
  | { message: "GetSearchMessageList"; params: { search: string } }
  | { message: "GetPatientChatDetail"; params: { patient: number } }
  | {
      message: "HandleOpenLinkEncounter";
      params: {
        type?: string;
        event?: MouseEvent;
        encounterId: string;
        href?: string;
        django?: any;
        replace?: string;
        doctorId?: number;
      };
    }
  | { message: "GetPatientAppointmentList"; params: { patient: number; division: number; card?: string } }
  | { message: "GetPatientDiagFormList"; params: { patient: number; division: number;} }
  | { message: "GetPatientDiagFormFilter"; params: { patient: number; division: number; activePage: number; filter: DiagFormFilter; } }
  | { message: "GetProxyPatient"; params: { patient: number } }
  | { message: "GetPatientNoteList"; params: { patient: number } }
  | { message: "SavePatientNote"; params: { patient: number; note: string } }
  | { message: "UpdatePatientNote"; params: { id: number; patient: number; note: string } }
  | { message: "DeletePatientNote"; params: { id: number; patient: number } }
  | { message: "GetPatientAppointmentDetail"; params: { id: number } }
  | { message: "GetDiagFormList"; params: { division: number } }
  | { message: "GetFormCategoryList"; params: { division: number } }
  | { message: "GetUsableAIList"; params: { division: number } }
  | { message: "GetOfficialAccountList"; params: { division: number } }
  | {
      message: "HandleDoctorDivisionServiceBlockSchedule";
      params: {
        divisionID?: number | string;
        doctorID?: number | string;
        month: string;
        year: string;
        is_telemed?: boolean;
        card: string;
      };
    }
  | {
      message: "HandleDoctorDivisionServiceBlockScheduleNextMonthYear";
      params: {
        divisionID?: number | string;
        doctorID?: number | string;
        month: string;
        year: string;
        is_telemed?: boolean;
        card: string;
      };
    }
  | {
      message: "HandleGetTimeSlotByDate";
      params: { selectDate: string | string[]; card: string; selectTime?: string; all?: boolean };
    }
  | {
      message: "HandleCheckDuplicatePatientApp";
      params: { data: any; card: string; doctor?: any; autoCreate?: boolean };
    }
  | { message: "HandleCreatePatientAppointment"; params: { card: string; [key: string]: any } }
  | { message: "HandlePostponePatientAppointment"; params: { card: string; [key: string]: any } }
  | { message: "HandleCancelPatientAppointment"; params: { card: string; [key: string]: any } }
  | { message: "HandleConfirmPatientAppointment"; params: { card: string; [key: string]: any } }
  | { message: "GetAppointmentPackageOptions"; params: object }
  | { message: "GetAppointmentPackageCatalog"; params: { keyword?: string } }
  | { message: "HandleAddAppointmentPackage"; params: { packageId: number } }
  | {
      message: "GetCartPackageList";
      params: { patient?: number; keyword?: string; offset?: number; refresh?: boolean };
    }
  | {
      message: "GetCartPackageCount";
      params: { patient?: number; refresh?: boolean };
    }
  | { message: "GetCartPaymentLink"; params: { patient?: number } }
  | { message: "HandleAddCartPackage"; params: { packageId: number } }
  | { message: "HandleDecreaseCartPackage"; params: { packageId: number } };

export type Data = {
  division?: number;
  device?: number;
};

export const DataInitial = {};

type Handler = (controller: WasmController<State, Event, Data, Props>, params?: any) => any;

const formatMembers: Handler = async (
  controller,
  params: {
    channelId: number | string;
    chatRoomList: any[];
    isChatPatientOnly?: boolean;
    items: any[];
  }
) => {
  let { items } = params;

  if (params.channelId === "all") {
    let response: any[] = [];

    if (!params.isChatPatientOnly) {
      let promiseArr: any[] = [];

      promiseArr = items
        .map((item: any) => item.chat_channel_id)
        .map((id) =>
          UserChatSubscriptionList.list({
            apiToken: controller.apiToken,
            params: { chat_channel_id: id },
          })
        );

      response = await Promise.all(promiseArr);
    }

    items = items.map((item, index) => ({
      ...item,
      chat_channel_name_autogen:
        item.member_count === 1 ? "ห้องว่าง" : item.chat_channel_name_autogen,
      name: item.member_count === 1 ? "" : item.name,
      members: response[index]?.[0]?.items || [],
    }));
  } else if (params.channelId) {
    let member: any = {};

    if (!params.isChatPatientOnly) {
      [member] = await UserChatSubscriptionList.list({
        apiToken: controller.apiToken,
        params: { chat_channel_id: params.channelId },
      });
    }

    items = items.map((item, index) => ({
      ...item,
      chat_channel_name_autogen:
        item.member_count === 1 ? "ห้องว่าง" : item.chat_channel_name_autogen,
      name: item.member_count === 1 ? "" : item.name,
      members:
        params.channelId === item.chat_channel_id
          ? member?.items || []
          : (params.chatRoomList || []).find((acc) => item.chat_channel_id === acc.chat_channel_id)
              ?.members || [],
    }));
  }

  return items;
};

export const GetChatChannelList: Handler = async (controller, params) => {
  const state = controller.getState();

  const chatList = params.isChatPatientOnly
    ? await PatientQueueList.list({
        apiToken: controller.apiToken,
        params: {
          division: controller.data.division,
          search: params.search,
          signed_Only: true,
          unsigned_Only: true,
          unread_only: params.unread_only
        },
      })
    : await ChatChannelNoSubscriptionList.list({
        apiToken: controller.apiToken,
        params: {
          employee_only: true,
          search: params.search,
        },
      });

  let items: any[] = (chatList[0]?.items || [])
    .map((item: any) => ({
      ...item,
      chat_channel_id: item.chat_channel_id || item.chat_channel,
      division: item.division_id || item.division,
      chat_channel_name_autogen: item.chat_channel_name_autogen || item.patient_name,
      latest_message_content: item.latest_message_content || item.latest_message,
    }))
    .filter((item) => (params.isChatPatientOnly ? true : item.division == null));

  let allItems = params.isChatPatientOnly
    ? state.allAdminChatRoomIds || []
    : state.allChatRoomList || [];

  if (!params.all) {
    items = await formatMembers(controller, {
      items,
      channelId: params.channelId,
      chatRoomList: state.chatRoomList || [],
      isChatPatientOnly: params.isChatPatientOnly,
    });
  } else {
    allItems = items.map((item: any) => item.chat_channel_id);
  }

  const isNewChat = allItems.find(
    (id) => params.channelId !== id && typeof params.channelId === "number"
  );

  if (isNewChat) {
    allItems = [Number(params.channelId), ...allItems];
  }

  const isUnread = GetUnreadMessageCount(controller, {
    chatList: items,
    chatRoomId: params.chatRoomId,
  });

  const totalUnreadCount = items.reduce(
    (result: number, item: any) => result + Number(item.unread_message_count),
    0
  );

  controller.setState(
    params.isChatPatientOnly
      ? {
          [params.all ? "allAdminChatRoomIds" : "chatRoomList"]: [...items],
          allAdminChatRoomIds: allItems,
          ...(params.all && { allAdminChatRoomList: [...items] }),
          showIconNoti: isUnread,
          adminChatUnreadCount: totalUnreadCount > 99 ? "99+" : String(totalUnreadCount || ""),
        }
      : {
          [params.all ? "allChatRoomList" : "chatRoomList"]: [...items],
          allChatRoomList: allItems,
          showIconNoti: isUnread,
        }
  );

  return items;
};

export const GetUnreadMessageCountStaff: Handler = async (controller, params) => {
  await GetChatChannelList(controller, params);
};

export const GetUserChatSubscriptionList: Handler = async (controller, params) => {
  if (!params.chat_channel_id) {
    return controller.setState({ userChatSubscriptionList: [] });
  }

  const chat = await UserChatSubscriptionList.list({
    apiToken: controller.apiToken,
    params,
  });

  controller.setState({
    userChatSubscriptionList: chat[0].items || [],
  });
};

export const CreateUpdateChatRoom: Handler = async (controller, params) => {
  if (params.type === "create") {
    let chat: any = [null, null, null];

    if (!params.notChangeName) {
      chat = await (params.chatChannelId ? ChatChannelDetail.update : ChatChannelList.create)({
        apiToken: controller.apiToken,
        pk: params.chatChannelId,
        data: {
          name: params.groupName,
          basic: "true",
        } as any,
        extra: {
          division: controller.data.division,
        },
      });
    }

    return (await params.userIds?.length)
      ? UserChatSubscriptionList.create({
          apiToken: controller.apiToken,
          data: {
            list_user_id: params.userIds,
            chat_channel_id: params.chatChannelId || chat[0].chat_channel_id,
            action: params.action,
            force: "true",
          } as any,
          extra: {
            division: controller.data.division,
          },
        })
      : [null, null, null];
  } else if (params.type === "delete") {
    // if (params.isChangeName) {
    //   await CreateUpdateChatRoom(controller, {
    //     ...params,
    //     type: "change_name",
    //   });
    // }

    return await KickUserChatChannelDetail.update({
      apiToken: controller.apiToken,
      pk: params.chatChannelId,
      data: {
        list_user_id: params.userIds,
        action: "KICK",
      } as any,
    });
  } else if (params.type === "leave") {
    // if (params.isChangeName) {
    //   await CreateUpdateChatRoom(controller, {
    //     ...params,
    //     type: "change_name",
    //   });
    // }

    return await UserChatSubscriptionDetail.update({
      apiToken: controller.apiToken,
      pk: params.userChatSubscriptionId,
      data: {
        action: "LEAVE",
      },
    });
  } else if (params.type === "change_name") {
    return await ChatChannelDetail.update({
      apiToken: controller.apiToken,
      pk: params.chatChannelId,
      data: {
        name: params.groupName,
        basic: "true",
      } as any,
      extra: {
        division: controller.data.division,
      },
    });
  }
};

const GetMessageSearch: Handler = (controller, params) => {
  return MessageSearchView.list({
    apiToken: controller.apiToken,
    chat_channel_id: params.chatChannelId,
    params: {
      search: params.search,
      offset: params.offset,
      last: params.last,
    },
  });
};

export const GetSearchMessageList: Handler = async (controller, params) => {
  if (params.clear) {
    return controller.setState({ searchMessageList: {} });
  }

  const state = controller.getState();

  let result: any = {};

  if (params.previous) {
    [result] = await controller.handleEvent({
      message: "getMessageFromURL",
      params: { apiToken: controller.apiToken, url: params.previous },
    } as any);
  } else {
    [result] = await GetMessageSearch(controller, params);
  }

  const item = Array.isArray(result?.items) ? { items: result.items, count: result.total } : {};

  if (item.items) {
    item.items = item.items.reverse();
  }

  if (params.concat) {
    item.items = [...(state.searchMessageList?.items || []), ...(item.items || [])];

    const key = "id";
    const arrayUniqueByKey: any[] = Array.from(
      new Map(item.items.map((item: any) => [item[key], item])).values()
    );

    item.items = arrayUniqueByKey;
  }

  controller.setState({ searchMessageList: { ...item, page: params.page } });
};

export const GetPatientChatDetail: Handler = async (controller, params) => {
  const [patient] = await PatientDetailView.retrieve({
    pk: params.patient,
    apiToken: controller.apiToken,
  });

  controller.setState({
    selectedPatientChat: patient,
  });
};

// card ของ loadingStatus สำหรับรายการนัดหมาย — ProfilePanel / BookingSection ใช้ key ตรงกัน
export const PatientAppointmentListCard = "GET_PATIENT_APPOINTMENT_LIST";

// เขียน loadingStatus / errorMessage แบบ function-updater แก้ spinner ไม่เคยปิด
const patchLoadingStatus = (controller: any, card: string, value: boolean) => {
  controller.setState((prev: any) => ({
    loadingStatus: { ...(prev.loadingStatus || {}), [card]: value },
  }) as any);
};

const patchErrorMessage = (controller: any, card: string, value: any) => {
  controller.setState((prev: any) => ({
    errorMessage: { ...(prev.errorMessage || {}), [card]: value },
  }) as any);
};

export const GetPatientAppointmentList: Handler = async (controller, params) => {
  const card = params?.card || PatientAppointmentListCard;

  if (!params?.patient) {
    controller.setState({ selectedPatientAppointmentList: [] } as any);
    patchLoadingStatus(controller, card, false);
    return;
  }

  // ล้างรายการเดิมก่อนเสมอ (กันประวัตินัดของคนเก่าค้างอยู่) + ขึ้น loading แทน
  controller.setState({ selectedPatientAppointmentList: [] } as any);
  patchLoadingStatus(controller, card, true);

  try {
    const [appointments] = await PatientAppointmentView.list({
      apiToken: controller.apiToken,
      params: {
        patient_id: params.patient,
        division_id: params.division,
        limit: 9999,
      }
    });

    controller.setState({
      selectedPatientAppointmentList: appointments?.items || [],
    } as any);
  } catch (e) {
    console.error("[MSG] GetPatientAppointmentList failed", e);
    patchErrorMessage(controller, card, "โหลดรายการนัดหมายไม่สำเร็จ");
  } finally {
    patchLoadingStatus(controller, card, false);
  }
};

// --- สำหรับเรียกหน้า Panel
export const GetPatientDiagFormList: Handler = async (controller, params) => {
  const [diagForms] = await DiagFormList.list({
    apiToken: controller.apiToken,
    params: {
      patient: params.patient,
      division: params.division,
      latest: true,
      limit: 9999, // *
    },
  });

  controller.setState({
    selectedPatientDiagFormList: diagForms.items || [],
  });
};

export const GetOfficialAccountList: Handler = async (controller, params) => {
  const [r] = await OfficialAccountListView.list({
    apiToken: controller.apiToken,
    params: { search: params.search, disable_pagination: true },
  });

  controller.setState({
    officialAccountList: r?.items ?? [],
  });
};

// --- สำหรับ Filter Form Action
export const GetPatientDiagFormFilter: Handler = async (controller, params) => {
  const LIST_LIMIT = 10;

  const activePage = params.activePage ?? 1;
  const offset = (activePage - 1) * LIST_LIMIT;

  const formattedFilter = formattedDiagFormFilter(params.filter);

  controller.setState(prev => ({
    diagFormData: {
      ...prev.diagFormData,
      searchLoading: true,
    }
  }));

  const [diagForms] = await DiagFormList.list({
    apiToken: controller.apiToken,
    params: {
      patient: params.patient,
      division: params.division,
      offset,
      ...formattedFilter,
      limit: LIST_LIMIT,
    },
    extra: { division: controller.data.division },
  });

  controller.setState(prev => ({
    diagFormData: {
      ...prev.diagFormData,
      searchLoading: false,
      activePage,
      items: diagForms?.items ?? [],
      total: diagForms?.total ?? 0,
    },
  }));
};

export const GetProxyPatient: Handler = async (controller, params) => {
  const [proxyPatient] = await ProxyPatientDetail.retrieve({
    apiToken: controller.apiToken,
    pk: params.patient,
    // params: {},
  });

  controller.setState({
    selectedProxyPatient: proxyPatient,
  });
};

export const GetPatientNoteList: Handler = async (controller, params) => {
  const [notes] = await PatientNoteListView.list({
    apiToken: controller.apiToken,
    params: {
      patient: params.patient,
      active: true,
    },
    extra: { division: controller.data.division },
  });

  controller.setState({
    selectedPatientNoteList: notes?.items || [],
  });
};

export const SavePatientNote: Handler = async (controller, params) => {
  const [saveNoteResp, saveNoteErr] = await PatientNoteListView.create({
    apiToken: controller.apiToken,
    data: {
      patient: params.patient,
      note: params.note,
    },
    extra: { division: controller.data.division },
  });

  if (saveNoteErr || !saveNoteResp) {
    patchErrorMessage(controller, "StaffChat", saveNoteErr);

    return;
  }

  const patient = saveNoteResp?.patient;

  // Update Patient Note List
  await GetPatientNoteList(controller, { patient });
};

export const UpdatePatientNote: Handler = async (controller, params) => {
  const [updateNoteResp, updateNoteErr] = await PatientNoteDetailView.update({
    apiToken: controller.apiToken,
    pk: params.id,
    data: {
      patient: params.patient,
      note: params.note,
    },
    extra: { division: controller.data.division },
  });

  if (updateNoteErr || !updateNoteResp) {
    patchErrorMessage(controller, "StaffChat", updateNoteErr);

    return;
  }

  // Update Patient Note List
  await GetPatientNoteList(controller, { patient: params.patient });
};

export const DeletePatientNote: Handler = async (controller, params) => {
  const [delNoteResp, delNoteErr, delNoteNet] = await PatientNoteDetailView.delete({
    apiToken: controller.apiToken,
    pk: params.id,
    extra: { division: controller.data.division },
  });

  if (delNoteErr || delNoteNet?.status !== 204) {
    patchErrorMessage(controller, "StaffChat", delNoteErr);

    return;
  }

  // Update Patient Note List
  await GetPatientNoteList(controller, { patient: params.patient });
};

export const GetDiagFormList: Handler = async (controller, params) => {
  const [diagFormResp, diagFormErr] = await DiagRuleList.list({
    apiToken: controller.apiToken,
    params: {
      division: params.division,
      active: true,
      limit: 9999, // *
    },
    extra: { division: controller.data.division },
  });

  if (diagFormErr || !diagFormResp?.items) return;

  controller.setState(prev => ({
    diagFormData: {
      ...prev.diagFormData,
      diagFormList: diagFormResp.items || [],
    },
  }));
};

export const GetFormCategoryList: Handler = async (controller, params) => {
  const [formCateResp, formCateErr] = await FormCategoryList.list({
    apiToken: controller.apiToken,
    params: {
      division: params.division,
      limit: 9999, // *
    },
    extra: { division: controller.data.division },
  });

  if (formCateErr || !formCateResp) return;

  controller.setState(prev => ({
    diagFormData: {
      ...prev.diagFormData,
      formCategoryList: formCateResp.items || [],
    },
  }));
};

export const GetUsableAIList: Handler = async (controller, params) => {
  const [aiBotLists, aiBotListsError] = await ChatbotList.list({
    apiToken: controller.apiToken,
    extra: { division: params.divisionId },
  });


  if (aiBotListsError || !aiBotLists)  {
     controller.setState({aiBotLists: {
      divisionId: params.divisionId,
      aiLists: [],
    }})
    return;
  }


  let aiLists: any[] = [];
  if (aiBotLists?.items?.length > 0 ) {
    aiLists = aiBotLists?.items
  }

  const resultCheckingList = await Promise.all(
    aiLists.map(async (aiItem) => {
      const checkResult = await CheckCanUseMeHealthServiceView.get({
        apiToken: controller.apiToken,
        params: {
          service_code: aiItem?.name,
          specific_datetime: moment().toISOString(),
        },
        extra: { division: params.divisionId },
      });
      return { name: aiItem?.name, result: checkResult };
    })
  );

   aiLists = aiLists.filter((ai: any, index: number) => {
    if (resultCheckingList[index].result?.[0]?.[ai.name]?.can_use) {
      return true
    }
    return false
  })

  controller.setState((prev) => ({
    aiBotLists: {
      divisionId: params.divisionId,
      aiLists: aiLists,
    },
  }));

};


const GetUnreadMessageCount: Handler = (controller, params) => {
  const sum = params.chatList
    .filter((item: any) => item.id !== params.chatRoomId)
    .reduce((result: number, item: any) => (result += item.unread_message_count || 0), 0);

  if (sum >= 1) {
    return true;
  } else {
    return false;
  }
};

export const HandleOpenLinkEncounter: Handler = async (
  controller,
  params: Extract<Event, { message: "HandleOpenLinkEncounter" }>["params"]
) => {
  const state = controller.getState();

  const e = params.event;
  const doctorId = params.doctorId || state.currentDoctor?.id;
  const clickLeft = e?.button === 0;
  const element = e?.target as HTMLAnchorElement | null;
  let loader = element?.querySelector(".ui.mini.active.loader") as HTMLAnchorElement | null;
  const isContext = params.type === "contextmenu";

  if (e && params.encounterId && !isContext) {
    e.preventDefault();
    e.stopPropagation();
  }

  if (isContext) {
    return loader?.remove();
  }

  if (loader) {
    return;
  }

  const django = params.django || controller.getState().django;

  if (params.encounterId) {
    element?.insertAdjacentHTML(
      "afterbegin",
      `<div class="ui mini active loader" style="left: -7px;"/>`
    );

    const result = await EncounterDetail.retrieve({
      apiToken: controller.apiToken,
      pk: params.encounterId,
    });

    const encounter = result[0] || {};

    if (encounter.id) {
      const isDoctor = django?.user?.role_types?.includes("DOCTOR");
      const isActive =
        (doctorId === encounter.student || doctorId === encounter.doctor) && isDoctor;
      // &&
      // encounter.is_expired === false;

      // #const isNotPermission = isDoctor && doctorId !== encounter.student && doctorId !== encounter.doctor;

      // console.log(isActive, params, encounter)

      if (isActive) {
        // if (encounter.status === "IN_EXAM") {
        //   if (params.href) {
        //     if (clickLeft){
        //       window.open(params.href, "_blank", "noopener noreferrer")?.focus();
        //     }
        //   }
        // } else
        if (["ARRIVING", "IN_QUEUE", "IN_EXAM", "CHECKED_OUT"].includes(encounter.status)) {
          if (params.href && clickLeft) {
            window.open(params.href, "_blank", "noopener noreferrer")?.focus();
          }
        } else if (clickLeft || params.replace) {
          controller.setState({
            modOpenLinkEncounter: `ไม่สามารถดำเนินการได้ เนื่องจากผู้ป่วย\n“${encounter.status_name}”`,
          });
        }
      } else if (clickLeft || params.replace) {
        controller.setState({
          modOpenLinkEncounter: "ไม่มีสิทธิในการดำเนินการ",
        });
      }

      loader = element?.querySelector(".ui.mini.active.loader") as HTMLAnchorElement | null;
      loader?.remove();

      return encounter;
    }
  }
};

export const GetPatientAppointmentDetail: Handler = async (controller, params) => {
  return PatientAppointmentUpdate.retrieve({
    apiToken: controller.apiToken,
    pk: params.id,
  });
};

// Utils
export const getAddressDetail = (state: Record<string, any> = {}) => {
  const type = state?.serviceLocationType || state?.extra?.service_location_type;
  const address = state?.location?.address || state?.extra?.address || {};
  const officialAccount = state?.officialAccount || state.extra?.official_account || {};

  if (type === "home") {
    return {
      name: address.name || "",
      address: address.full_address_text || "",
      image: "",
      type,
      latitude: address.latitude,
      longitude: address.longitude,
      icon: "/images/common/icon_home_solid_pink.png",
    };
  }

  const divisionName =
    officialAccount.division_name || officialAccount.name || state.division_name || "";
  const divisionAddress = officialAccount.address_text || state.division_location || "";

  return {
    name: divisionName,
    address: divisionAddress,
    image: officialAccount.image_file,
    type,
    icon: "/images/common/icon_building_regular_pink.png",
    city: officialAccount.city,
    district: officialAccount.district,
    province: officialAccount.province,
  };
};

const formattedDiagFormFilter = (filter: DiagFormFilter): DiagFormFilter => {
  const formattedStartDate = convertBEDateToADDashDate(filter?.start_date);
  const formattedEndDate = convertBEDateToADDashDate(filter?.end_date);

  return {
    ...(filter?.form_type !== "ALL" ? { form_type: filter.form_type } : {}),
    ...(filter?.diag_rule !== "ALL" ? { diag_rule: filter.diag_rule } : {}),
    start_date: formattedStartDate,
    end_date: formattedEndDate,
  };
};

// ==============================================================================================
// BookingSection (SelectDatetime flow) — logic ยกมาจาก ishealth-main
// (patient-lib/MobIsHealthInterface.ts + patient-lib/MobIsHealthProviderInterface.ts)
// ปรับให้เข้ากับ state ของ MSG: ใช้ selectedPatientChat แทน patientData/userProfile
// ==============================================================================================

// กัน response เก่าทับของใหม่ (สลับสถานที่/เปลี่ยนวันเร็ว ๆ แล้ว calendar + chip เพี้ยน)
// ใช้ได้เฉพาะ request ล่าสุดของแต่ละ kind เท่านั้น
let latestDsbRequestKey = "";
let latestTimeSlotRequestKey = "";

const dsbRequestKey = (params: any) =>
  `${params?.divisionID}|${params?.month}|${params?.year}|${params?.is_telemed}`;

const recursiveDoctorDivisionServiceBlockSchedule = async (
  params: any,
  apiToken: any,
  loadLimit: number,
) => {
  const [r, e, n] = await DoctorDivisionServiceBlockSchedule.list({
    params: {
      division: params?.divisionID,
      doctor: params?.doctorID,
      month: params?.month,
      year: params?.year,
      is_telemed: params?.is_telemed,
      exclude_onsite_only: true,
      ...(params?.limit && { limit: params.limit }),
      ...(params?.offset && { offset: params.offset }),
    },
    apiToken: apiToken,
  });

  if (e) {
    console.error("[MSG][DSB] DoctorDivisionServiceBlockSchedule.list failed", e);
    return [];
  } else if (!r || !Array.isArray(r?.items)) {
    console.warn("[MSG][DSB] unexpected response", r);
    return [];
  } else {
    if (r.next && loadLimit > 0) {
      const url = new URL(r.next);
      const paramsURL = new URLSearchParams(url.search);
      const newParams = {
        ...params,
        limit: paramsURL.get("limit"),
        offset: paramsURL.get("offset"),
      };
      const scheduleList: any =
        await recursiveDoctorDivisionServiceBlockSchedule(
          newParams,
          apiToken,
          loadLimit - 1,
        );
      return [...r?.items, ...scheduleList];
    } else {
      return r?.items;
    }
  }
};

export const HandleDoctorDivisionServiceBlockSchedule: Handler = async (
  controller,
  params,
) => {
  let state = controller.getState();

  // MSG: ถ้า UI ไม่ได้ส่ง divisionID มา ให้ใช้ division ที่ staff กำลังทำงานอยู่
  params = {
    ...params,
    divisionID:
      // UI ส่ง divisionID เป็น "" ได้ (ยังไม่เลือกสถานที่) → ?? ไม่ fallback ต้องใช้ ||
      params?.divisionID ||
      (state as any)?.selectedDivision?.id ||
      (controller.getState() as any)?.selectedDivision?.id,
  };

  if (!params.divisionID) {
    console.warn(
      "[MSG][DSB] HandleDoctorDivisionServiceBlockSchedule: ไม่มี divisionID — skip API call",
      params,
    );
    patchLoadingStatus(controller, params.card, false);
    return;
  }

  const requestKey = dsbRequestKey(params);
  latestDsbRequestKey = requestKey;

  patchLoadingStatus(controller, params.card, true);

  const scheduleList = await recursiveDoctorDivisionServiceBlockSchedule(
    params,
    controller.apiToken,
    4,
  );

  // มี request ใหม่กว่าเรียกไปแล้ว — ผลตัวนี้เก่าทิ้ง (ตัวใหม่จะเป็นคนเขียน state เอง)
  if (latestDsbRequestKey !== requestKey) {
    return;
  }

  controller.setState((prev: any) => ({
    createAppointment: {
      ...prev?.createAppointment,
      doctorDivisionServiceBlockSchedule: scheduleList || [],
    },
    loadingStatus: { ...(prev.loadingStatus || {}), [params.card]: false },
  }) as any);
};

export const HandleDoctorDivisionServiceBlockScheduleNextMonthYear: Handler =
  async (controller, params) => {
    let state = controller.getState();

    // MSG: ถ้า UI ไม่ได้ส่ง divisionID มา ให้ใช้ division ที่ staff กำลังทำงานอยู่
    params = {
      ...params,
      divisionID:
        // เช่นเดียวกับ HandleDoctorDivisionServiceBlockSchedule ("" ต้อง fallback)
        params?.divisionID ||
        (state as any)?.selectedDivision?.id ||
        (controller.getState() as any)?.selectedDivision?.id,
    };

    if (!params.divisionID) {
      console.warn(
        "[MSG][DSB] HandleDoctorDivisionServiceBlockScheduleNextMonthYear: ไม่มี divisionID — skip API call",
        params,
      );
      patchLoadingStatus(controller, params.card, false);
      return;
    }

    patchLoadingStatus(controller, params.card, true);

    const requestKey = dsbRequestKey(params);
    latestDsbRequestKey = requestKey;

    const scheduleList = await recursiveDoctorDivisionServiceBlockSchedule(
      params,
      controller.apiToken,
      4,
    );

    if (latestDsbRequestKey !== requestKey) {
      return;
    }

    controller.setState((prev: any) => ({
      createAppointment: {
        ...prev?.createAppointment,
        doctorDivisionServiceBlockSchedule:
          [
            ...(prev?.createAppointment?.doctorDivisionServiceBlockSchedule ||
              []),
            ...scheduleList,
          ] || [],
      },
      loadingStatus: { ...(prev.loadingStatus || {}), [params.card]: false },
    }) as any);
  };

const expandDateRange = (selectDate: string | string[]): string[] => {
  let selectDates = Array.isArray(selectDate)
    ? selectDate
    : selectDate
    ? [selectDate, selectDate]
    : [];

  if (selectDates.length === 2) {
    const startDate = moment(selectDates[0]);
    const diffDays = moment(selectDates[1]).diff(startDate, "days");

    selectDates = Array.from({ length: diffDays + 1 }, (_, index) =>
      startDate.clone().add(index, "days").format("YYYY-MM-DD"),
    );

    if (selectDates.length === 1) {
      selectDates.push(selectDates[0]);
    }
  }

  return selectDates;
};

const buildReservedTimeByDSB = (
  appointments: any[],
  currentPatientId: number,
  dsbSchedules: any[],
): Record<number, { start: string; end: string }[]> => {
  const reservedTimeByDSB: Record<number, { start: string; end: string }[]> =
    {};

  appointments
    .filter((item) => currentPatientId !== item.patient)
    .forEach((item) => {
      const appointmentTime = beMoment(item.estimated_at_iso);
      const dsbId = item.division_service_block;

      const dsb = dsbSchedules.find((d) => d.id === dsbId);
      const slotLength = dsb?.slot_length;

      if (!reservedTimeByDSB[dsbId]) {
        reservedTimeByDSB[dsbId] = [];
      }

      reservedTimeByDSB[dsbId].push({
        start: appointmentTime.format("HH:mm"),
        end: appointmentTime.clone().add(slotLength, "minutes").format("HH:mm"),
      });
    });

  return reservedTimeByDSB;
};

const buildReservedTimeByPatient = (
  appointments: any[],
  currentPatientId: number,
  editingDSBId?: number,
  editingTime?: string,
): string[] => {
  return (
    appointments
      ?.filter((item) => {
        const isCurrentPatient = currentPatientId === item.patient;
        const isCurrentEditingSlot =
          editingDSBId === item.division_service_block &&
          beTimeStr(item.estimated_at_iso) === editingTime;

        return isCurrentPatient && !isCurrentEditingSlot;
      })
      .map((item) => beTimeStr(item.estimated_at_iso)) || []
  );
};

const generateAvailableTimeSlots = (
  dsb: any,
  reservedTimeByDSB: Record<number, { start: string; end: string }[]>,
  reservedTimeByPatient: string[],
): string[] => {
  const totalMinutes = beMoment(dsb.end_datetime_iso).diff(
    beMoment(dsb.start_datetime_iso),
    "minutes",
  );
  const totalSlots = totalMinutes / dsb.slot_length;
  const timeValue: string[] = [];
  // วันนี้/ตอนนี้ของ server — ไม่ใช้ timezone ของ browser
  const toDate = beNowDateStr();
  const timeNow = beNowTimeStr();

  for (let i = 0; i < totalSlots; i++) {
    const slotStart = beMoment(dsb.start_datetime_iso).add(
      dsb.slot_length * i,
      "minutes",
    );
    const slotEnd = slotStart.clone().add(dsb.slot_length, "minutes");
    const time = slotStart.format("HH:mm");

    // ตรวจสอบว่าทับกับ appointment ของคนอื่นไหม
    const isReservedByDSB =
      reservedTimeByDSB[dsb.id]?.some(
        (r) =>
          slotStart.format("HH:mm") < r.end && slotEnd.format("HH:mm") > r.start,
      ) || false;

    const isReservedByPatient = reservedTimeByPatient.includes(time);
    const isToday = toDate === beDateStr(dsb.start_datetime_iso);
    const isFutureTime = timeNow < time;

    const isAvailable =
      !isReservedByDSB && !isReservedByPatient && (!isToday || isFutureTime);

    if (isAvailable) {
      timeValue.push(time);
    }
  }

  return timeValue;
};

const groupDSBByPeriodTime = (
  dsbSchedules: any[],
  selectDates: string[],
  availableDSBs: any[],
  reservedTimeByDSB: Record<number, { start: string; end: string }[]>,
  reservedTimeByPatient: string[],
) => {
  const dataTime: string[] = [];
  const dataTimeAndDoctorDSB: any[] = [];

  dsbSchedules.forEach((item) => {
    const itemDate = beDateStr(item.start_datetime_iso);
    const isSelectedDate = selectDates.includes(itemDate);
    const isDSBAvailable = availableDSBs.some((itemDSB) => itemDSB.id === item.id);

    if (!(isSelectedDate && isDSBAvailable)) {
      return;
    }

    const textTime = `${beTimeStr(item.start_datetime_iso)} - ${beTimeStr(
      item.end_datetime_iso,
    )}`;

    if (!dataTime.includes(textTime)) {
      dataTime.push(textTime);
      dataTimeAndDoctorDSB.push({ periodTime: textTime, doctorDSB: [] });
    }

    const indOfDataTime = dataTime.indexOf(textTime);
    const totalMinutes = beMoment(item.end_datetime_iso).diff(
      beMoment(item.start_datetime_iso),
      "minutes",
    );
    const totalSlots = Math.floor(totalMinutes / item.slot_length);
    const timeValue = generateAvailableTimeSlots(
      item,
      reservedTimeByDSB,
      reservedTimeByPatient,
    );

    const dsbIds = Object.keys(reservedTimeByDSB);

    dataTimeAndDoctorDSB[indOfDataTime]["doctorDSB"].push({
      ...item,
      has_appointment: dsbIds.includes(String(item.id)),
      scheduled_count: (reservedTimeByDSB[item.id] || []).length,
      total_slots: totalSlots,
      timeValue,
    });
  });

  return dataTimeAndDoctorDSB;
};

const fetchAndProcessTimeSlots = async (params: {
  apiToken?: string;
  selectDates: string[];
  createAppointment: any;
  userProfile: any;
  appointmentData: any;
  selectTime?: string;
  all?: boolean;
}): Promise<{ timeDivision: any[]; filteredTimeDivision: any[] }> => {
  const {
    apiToken,
    selectDates,
    createAppointment,
    userProfile,
    appointmentData,
    selectTime,
    all = false,
  } = params;

  // 1. Fetch appointment list
  const [response]: any = await PatientAppointmentView.list({
    apiToken,
    params: {
      status: 1,
      start_date: selectDates[0] ? dateToStringWithoutTimeBE(selectDates[0]) : "",
      end_date: selectDates[1] ? dateToStringWithoutTimeBE(selectDates[1]) : "",
      // DRF ใช้ DGridPagination PAGE_SIZE=100 → ไม่ขอ limit จะได้แค่วันละ 100 นัด
      // reservedTimeByDSB ไม่ครบ → แสดงเวลาว่าว่างทั้งที่เต็ม (double booking)
      limit: 9999,
    },
  });

  // 2. Filter DSB by selected date
  const filterDSB =
    createAppointment?.doctorDivisionServiceBlockSchedule?.filter((item: any) =>
      selectDates.includes(
        moment(item.start_datetime_iso, "YYYY-MM-DD").format("YYYY-MM-DD"),
      ),
    ) || [];

  // 3. Extract DSB IDs
  const dsbData: number[] = filterDSB.map((item: any) => item.id);

  // 4. Fetch available DSB
  let resDSB: any[] = [];
  if (all) {
    resDSB = (
      createAppointment?.doctorDivisionServiceBlockSchedule ?? []
    ).filter((item: any) => dsbData.includes(item.id));
  } else if (dsbData.length > 0) {
    [resDSB] = await DivisionServiceBlockAvailableList.create({
      apiToken,
      data: { dsb: dsbData, exclude_onsite_only: true },
    });
  }

  // 5. Build reserved times
  const reservedTimeByDSB = buildReservedTimeByDSB(
    response?.items || [],
    userProfile?.patient,
    createAppointment?.doctorDivisionServiceBlockSchedule || [],
  );

  const reservedTimeByPatient = buildReservedTimeByPatient(
    response?.items || [],
    userProfile?.patient,
    appointmentData.division_service_block,
    selectTime,
  );

  // 6. Build time slots
  const dataTimeAndDoctorDSB = groupDSBByPeriodTime(
    createAppointment?.doctorDivisionServiceBlockSchedule || [],
    selectDates,
    resDSB ?? [],
    reservedTimeByDSB,
    reservedTimeByPatient,
  );

  // 7. เก็บเฉพาะ division ที่มี slot ว่างจริง
  // เดิมใช้ .every → ถ้าหมอคนหนึ่งในช่วงเดียวกันเต็มทั้งช่วง slot ของหมอคนอื่นในช่วงนั้น
  // จะหายไปทั้งกลุ่ม ทำให้วันที่มีแต่ช่วงเวลาบ่าย slot ว่างถูกกรองทิ้งทั้งหมด
  // (UI จึงเห็นทั้งเช้าและบ่ายถูก disable)
  const filteredTimeDivision = dataTimeAndDoctorDSB.filter((item: any) =>
    (item?.doctorDSB || []).some((times: any) => (times?.timeValue || []).length > 0),
  );

  return {
    timeDivision: dataTimeAndDoctorDSB,
    filteredTimeDivision,
  };
};

export const HandleGetTimeSlotByDate: Handler = async (controller, params) => {
  const { selectedPatientChat } = controller.getState();
  const apiToken = controller.apiToken;
  // MSG: ใช้ patient จาก selectedPatientChat แทน userProfile ของ ishealth-main
  const userProfile = { patient: selectedPatientChat?.id };

  // แปลง date range เป็น array ของวันที่
  const selectDates = expandDateRange(params.selectDate);
  // รวม divisionID ใน key ด้วย — สลับสถานที่แต่วันเดียวกัน นับเป็นคนละ request
  const requestKey = `${params?.divisionID ?? ""}|${selectDates.join("~")}`;
  latestTimeSlotRequestKey = requestKey;

  // Set loading state
  controller.setState({ timeDivision: [] } as any);
  patchLoadingStatus(controller, params.card, true);

  // อ่าน createAppointment จาก state ทุก round (ไม่ snapshot ตอนเข้าฟังก์ชัน)
  // + ขอซ้ำได้ 2 round: ถ้าระหว่างรอมีโหลดตาราง DSB (ปฏิทินของแผนก / เดือนถัดไป) มาเขียนทับ
  // slot ที่คำนวณจากตารางเก่าใช้ไม่ได้ — เดิมทิ้งเงียบ ๆ ทำให้ timeDivision ค้างว่าง
  // (วันนั้นมีบ่ายให้เลือกแต่ UI ไม่ขึ้น ต้องกดวันอื่นแล้วกดกลับถึงจะขึ้น)
  const MAX_ATTEMPTS = 2;

  for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
    // snapshot DSB ที่ใช้คำนวณ round นี้ (เทียบหลัง fetch ว่าถูกเขียนทับไปหรือยัง)
    const createAppointment = (controller.getState() as any)?.createAppointment;
    const dsbSnapshot = createAppointment?.doctorDivisionServiceBlockSchedule;

    // Fetch และประมวลผล time slots
    const { timeDivision, filteredTimeDivision } = await fetchAndProcessTimeSlots({
      apiToken,
      selectDates,
      createAppointment,
      userProfile,
      appointmentData: {},
      selectTime: params?.selectTime,
      all: params.all,
    });

    // มี request ของวัน/แผนกใหม่กว่าเรียกไปแล้ว — ของใหม่เป็นคนเขียน state เอง
    if (latestTimeSlotRequestKey !== requestKey) {
      return;
    }

    // สลับสถานที่ระหว่างรอ / ปฏิทินโหลดเสร็จทีหลัง: controller มี DSB ชุดใหม่แล้ว
    const currentDsb = (controller.getState() as any)?.createAppointment
      ?.doctorDivisionServiceBlockSchedule;

    if (currentDsb !== dsbSnapshot) {
      // ตาราง DSB เปลี่ยนหลัง request นี้ออกไป → คำนวณใหม่ด้วยตารางล่าสุด
      if (attempt < MAX_ATTEMPTS) {
        continue;
      }

      // ยังเปลี่ยนอีก (เป็น request ที่ตก ไม่มี request ใหม่มาเคลียร์ flag ให้)
      // → ปิด loading เอง กัน spinner ค้าง
      patchLoadingStatus(controller, params.card, false);
      return;
    }

    controller.setState((prev: any) => ({
      timeDivision: params.all ? timeDivision : filteredTimeDivision,
      loadingStatus: { ...(prev.loadingStatus || {}), [params.card]: false },
    }) as any);

    return;
  }
};

export const HandleCheckDuplicatePatientApp: Handler = async (
  controller,
  params,
) => {
  const state = controller.getState();

  if (!state.selectedPatientChat?.id || !params.data?.estimated_at_iso) {
    patchErrorMessage(controller, params.card, "ยังเลือกวัน/เวลาไม่ครบ หรือไม่มีข้อมูลผู้ป่วย");
    return;
  }

  patchLoadingStatus(controller, params.card, true);

  const data = params.data;

  const [result] = await PatientAppointmentView.list({
    apiToken: controller.apiToken,
    params: {
      patient_id: state.selectedPatientChat?.id,
      start_datetime: data.start_datetime_iso,
      end_datetime: data.end_datetime_iso,
    },
  });

  const items: Record<string, any>[] = result?.items ?? [];

  const foundAppointment = items.find(
    // เทียบ wall clock — backend ตอบ naive, frontend ส่งแบบมี offset (เทียบ string ตรง ๆ ไม่ได้)
    (item) => beStampStr(item.estimated_at_iso) === beStampStr(data.estimated_at_iso),
  );

  if (foundAppointment) {
    patchLoadingStatus(controller, params.card, false);
    patchErrorMessage(controller, params.card, "มีนัดหมายในช่วงเวลานี้แล้ว ไม่สามารถซ้ำเวลาได้");

    return;
  }

  patchLoadingStatus(controller, params.card, false);
  patchErrorMessage(controller, params.card, null);

  // main app เดิน history ไป /service-payment/ เพื่อ confirm อีกขั้น
  // MSG ไม่มี router — สร้างนัดต่อใน controller เลย (ปิดได้ด้วย params.autoCreate = false)
  if (params.autoCreate !== false) {
    await HandleCreatePatientAppointment(controller, {
      ...params,
      slot: params.data,
    });
  }
};

// ============================================================================
// สร้างนัดหมาย — port จาก ishealth-main (MobIsHealthProviderInterface:
//   HandleConfirmPayment + CreatePackagePatientAppointment + GetAppointmentPackageItems)
// ปรับ: patientData -> selectedPatientChat, ไม่เดิน history / ไม่มีการชำระ (staff flow)
// ============================================================================

// DRF ValidationError (และ axios error) → ข้อความสั้นสำหรับแสดงใน UI
// หมายเหตุ: generated API คืน [data, errorResponseBody, rawError]
const extractApiErrorMessage = (error: any): string => {
  if (!error) {
    return "";
  }

  if (typeof error === "string") {
    return error;
  }

  const data = error.responseData ?? error;

  if (typeof data === "string") {
    return data;
  }

  const detail = data?.detail || data?.error?.detail;
  if (detail) {
    return String(detail);
  }

  const preferredKeys = [
    "non_field_errors",
    "estimated_at",
    "repetition_note",
    "division",
    "division_service_block",
    "patient",
  ];

  for (const key of preferredKeys) {
    const value = data?.[key];
    if (value) {
      return Array.isArray(value) ? String(value[0]) : String(value);
    }
  }

  const firstMessage: any = Object.values(data ?? {})
    .flat()
    .find((value: any) => typeof value === "string");

  return firstMessage ? String(firstMessage) : "";
};

const getAppointmentPackageOrders = (packages: any[]) =>
  packages.map((item: any) => ({
    id: item.id,
    package_type: item.package_type,
    package_type_name: item.package_type_name,
    product: item.product,
    product_name: item.product_name,
    product_name_en: item.product_name_en,
    product_code: item.product_code,
    custom_status: item.custom_status,
    price: item.price,
    quantity: item.quantity,
  }));

const getAppointmentPackageItems = async (controller: any, packages: any[]) => {
  const details = await Promise.all(
    packages.map((item: any) =>
      PackageDetail.retrieve({
        apiToken: controller.apiToken,
        pk: item.product,
      }),
    ),
  );

  return packages.flatMap((item: any, index: number) => {
    const isOnlyOnce =
      details[index]?.[0]?.usage_limit === "ONLY_ONCE_IN_ENCOUNTER";

    return (item.items || [])
      .filter((acc: any) => acc.active && Number(acc.quantity_left) > 0)
      .map((acc: any) => ({
        package_order_item: acc.id,
        quantity_appointment: isOnlyOnce ? acc.quantity_left : 1,
      }));
  });
};

// แพ็กเกจผูกกับนัด: สร้าง appointment-package แล้วนัดถูกสร้างพร้อมกัน (ต้อง patch เพิ่ม)
const CreatePackagePatientAppointment = async (
  controller: any,
  data: Record<string, any>,
  packages: any[],
) => {
  const [appointmentPackage, packageError] = await AppointmentPackageList.create({
    apiToken: controller.apiToken,
    data: {
      patient: data.patient,
      dsb_id: data.division_service_block,
      doctor_note: "",
      items: await getAppointmentPackageItems(controller, packages),
      estimated_at: data.estimated_at_iso,
    } as any,
    extra: { division: data.division },
  });

  if (!appointmentPackage) {
    return {
      appointment: null,
      error: packageError ?? "สร้าง appointment-package ไม่สำเร็จ",
    };
  }

  const [patientApp, listError] = await PatientAppointmentView.list({
    apiToken: controller.apiToken,
    params: {
      patient_id: data.patient,
      division_id: appointmentPackage.order_division,
      exclude_cancel: true,
    },
  });

  const appointment = (patientApp?.items ?? []).find(
    (item: any) => item.content_id === appointmentPackage.id,
  );

  if (!appointment) {
    return {
      appointment: null,
      error:
        listError ??
        "ไม่พบนัดหมายที่ถูกสร้างจาก appointment-package (ต้องเปิดใช้ระบบนัดของแผนกก่อน)",
    };
  }

  const [result, patchError] = await PatientAppointmentUpdate.patch({
    apiToken: controller.apiToken,
    pk: appointment.id,
    data: {
      // serializer ของ backend validate division == division_service_block.division
      // และบน PATCH ต้องมี patient → ส่งติดไปให้ครบ ไม่งั้น 500/400
      patient: data.patient,
      division: data.division,
      division_service_block: data.division_service_block,
      order_note: data.order_note,
      estimated_duration: data.estimated_duration,
      repetition_note: data.repetition_note,
      send_message: data.send_message,
      // appointment-package สร้างเป็นยืนยันแล้ว → ตัง status เป็นรอยืนยัน (1) ตาม main
      status: 1,
      extra: {
        ...data.extra,
        package_orders: getAppointmentPackageOrders(packages),
      },
    } as any,
  });

  return { appointment: result || null, error: result ? null : patchError };
};

export const HandleCreatePatientAppointment: Handler = async (
  controller,
  params,
) => {
  const state = controller.getState();
  const patientId = params.patientId ?? state.selectedPatientChat?.id;
  const slot = params.slot ?? {};
  const officialAccount = params.officialAccount ?? {};
  const appointmentPackages: any[] = params.appointmentPackages ?? [];
  // backend (QUE/serializers.py) validate ว่า division ต้อง == dsb.division
  // → ใช้ division ของ DSB ที่เลือกเป็นอันดับแรก
  const division =
    slot?.division ??
    officialAccount?.division ??
    (state as any).selectedDivision?.id;

  if (!patientId || !slot?.estimated_at_iso) {
    patchErrorMessage(controller, params.card, "ยังเลือกวัน/เวลาไม่ครบ หรือไม่มีข้อมูลผู้ป่วย");
    return;
  }

  if (!division) {
    patchErrorMessage(controller, params.card, "ไม่ได้เลือกสถานที่รับบริการ");
    return;
  }

  patchLoadingStatus(controller, params.card, true);
  patchErrorMessage(controller, params.card, null);

  const data = {
    division,
    patient: patientId,
    division_service_block: slot?.id,
    order_note: (params.appointmentOrderNote || "").trim(),
    estimated_at_iso: slot?.estimated_at_iso,
    estimated_duration: slot?.slot_length,
    repetition_note: (params.repetitionNote || "").trim(),
    send_message: !params.appointment?.id,
    extra: {
      diag_form_id: params.basicSymptomInfo?.diagFormId,
      service_location_type: params.serviceLocationType,
      ...(officialAccount?.id && {
        official_account: {
          full_address_text: officialAccount.full_address_text,
          name: officialAccount.name,
          division_name: officialAccount.division_name,
          image_file: officialAccount.image_file,
          id: officialAccount.id,
          division: officialAccount.division,
          address_text: officialAccount.address_text,
        },
      }),
    },
  };

  let result: any = null;
  let apiError: any = null;

  try {
    if (params.appointment?.id) {
      // แก้ไขนัดเดิม (เลื่อนนัด)
      const [patched, error] = await PatientAppointmentUpdate.patch({
        apiToken: controller.apiToken,
        pk: params.appointment.id,
        data: {
          patient: data.patient,
          division: data.division,
          division_service_block: data.division_service_block,
          estimated_at_iso: data.estimated_at_iso,
          estimated_duration: data.estimated_duration,
          order_note: data.order_note,
        } as any,
      });
      result = patched;
      apiError = error;
    } else if (appointmentPackages.length) {
      const created = await CreatePackagePatientAppointment(
        controller,
        data,
        appointmentPackages,
      );
      result = created.appointment;
      apiError = created.error;
    } else {
      const [created, error] = await PatientAppointmentView.create({
        apiToken: controller.apiToken,
        data,
      });
      result = created;
      apiError = error;
    }
  } catch (e: any) {
    console.error("[MSG] HandleCreatePatientAppointment error", e);
    apiError = e?.responseData ?? e;
    result = null;
  }

  patchLoadingStatus(controller, params.card, false);

  if (!result) {
    patchErrorMessage(
      controller,
      params.card,
      extractApiErrorMessage(apiError) || "สร้างนัดหมายไม่สำเร็จ กรุณาลองอีกครั้ง",
    );
    return;
  }

  controller.setState({
    createdAppointment: { ...result, _created_at: moment().format() },
  });

  // refresh รายการนัดของผู้รับบริการให้ขึ้นทันที (division = เดียวกับที่ ProfilePanel ใช้โหลด)
  await GetPatientAppointmentList(controller, {
    patient: patientId,
    division: params.refreshDivision ?? division,
  });
};

// ============================================================================================
// เลื่อนนัด / ยกเลิกนัด — port จาก ishealth-main
//   HandlePostponeAppointment (patient-lib/MobIsHealthProviderInterface.ts)
//   HandleCancelAppointment   (patient-lib/MobIsHealthInterface.ts)
// หมายเหตุ: PATCH /apis/QUE/patient-appointment-update/<pk>/ validate ว่า
//   division == division_service_block.division (QUE/serializers.py) จึงต้องส่ง
//   patient + division + division_service_block ครบทุกครั้งที่ PATCH
// ============================================================================================

// โหลดรายการนัดของผู้รับบริการใหม่หลังทำรายการ (reuse GetPatientAppointmentList
// เพื่อให้ clear + loading เหมือนกันทุกทาง)
const RefreshPatientAppointmentAfterAction = async (
  controller: any,
  params: { patient?: number; division?: number },
) => {
  if (!params.patient) {
    return;
  }

  await GetPatientAppointmentList(controller, {
    patient: params.patient,
    division: params.division as any,
  });
};

// เขียน loadingStatus / errorMessage ของ card ใด card หนึ่ง
// (อ่าน state ล่าสุดเสมอ — กันเขียนทับค่าที่ handler อื่นตั้งไว้ระหว่าง await)
const setAppointmentActionStatus = (
  controller: any,
  card: string,
  options: { loading?: boolean; error?: string | null },
) => {
  if (options.loading !== undefined) {
    patchLoadingStatus(controller, card, options.loading);
  }

  if (options.error !== undefined) {
    patchErrorMessage(controller, card, options.error);
  }
};

// PATCH /apis/QUE/patient-appointment-update/<pk>/ — ตัวกลางของ เลื่อน / ยกเลิก / ยืนยัน
// backend (QUE/serializers.py) validate division == division_service_block.division
// จึงต้องส่ง patient + division + division_service_block ครบเสมอ
const PatchPatientAppointment = async (
  controller: any,
  params: {
    id?: number;
    card: string;
    appointment?: any;
    patient?: number;
    division?: number;
    division_service_block?: number;
    refreshDivision?: number;
    actionLabel: string;
    data: Record<string, any>;
  },
): Promise<any> => {
  const state = controller.getState();
  const appointment = params.appointment || {};
  const patientId = params.patient ?? appointment.patient ?? state.selectedPatientChat?.id;
  const division =
    params.division ?? appointment.division ?? (state as any).selectedDivision?.id;
  const dsbId = params.division_service_block ?? appointment.division_service_block;

  if (!params.id) {
    return null;
  }

  setAppointmentActionStatus(controller, params.card, { loading: true, error: null });

  if (!patientId) {
    setAppointmentActionStatus(controller, params.card, {
      loading: false,
      error: "ไม่พบข้อมูลผู้ป่วยของแชทนี้",
    });
    return null;
  }

  // นัดที่ไม่มี DSB ติดมา (เช่นสร้างจากหน้าอื่น) PATCH จะพังที่ backend → กันไว้พร้อมข้อความ
  if (!division || !dsbId) {
    setAppointmentActionStatus(controller, params.card, {
      loading: false,
      error: "นัดนี้ไม่มีข้อมูลแผนก/ช่วงเวลาบริการ (DSB) — ทำรายการจากหน้านี้ไม่ได้",
    });
    return null;
  }

  const [result, error] = await PatientAppointmentUpdate.patch({
    apiToken: controller.apiToken,
    pk: params.id,
    data: {
      patient: patientId,
      division,
      division_service_block: dsbId,
      ...params.data,
    } as any,
  });

  setAppointmentActionStatus(controller, params.card, { loading: false });

  if (!result) {
    setAppointmentActionStatus(controller, params.card, {
      error:
        extractApiErrorMessage(error) ||
        `${params.actionLabel}ไม่สำเร็จ กรุณาลองอีกครั้ง`,
    });
    return null;
  }

  await RefreshPatientAppointmentAfterAction(controller, {
    patient: patientId,
    division: params.refreshDivision ?? (state as any).selectedDivision?.id ?? division,
  });

  return result;
};

// เลื่อนนัดหมาย: เปลี่ยนเฉพาะวัน/เวลา (slot ใหม่) โดยคงสถานะเดิมของนัดไว้
export const HandlePostponePatientAppointment: Handler = async (controller, params) => {
  const appointment = params.appointment || {};
  const slot = params.slot || {};

  if (!params.id || !slot?.estimated_at_iso) {
    setAppointmentActionStatus(controller, params.card, {
      loading: false,
      error: "เลือกวัน/เวลาใหม่ไม่ครบ ไม่สามารถเลื่อนนัดได้",
    });
    return;
  }

  const result = await PatchPatientAppointment(controller, {
    id: params.id,
    card: params.card,
    appointment,
    patient: params.patient,
    // division ต้องเป็นของ DSB ที่เลือกใหม่ (backend validate ไว้)
    division: slot?.division ?? appointment.division,
    division_service_block: slot?.id,
    refreshDivision: params.refreshDivision,
    actionLabel: "เลื่อนนัดหมาย",
    data: {
      estimated_at_iso: slot?.estimated_at_iso,
      estimated_duration: slot?.slot_length,
      status_note: (params.note || "").trim() || "เจ้าหน้าที่เลื่อนนัดหมาย",
      order_note:
        params.orderNote !== undefined
          ? (params.orderNote || "").trim()
          : appointment.order_note,
      repetition_note: params.isChangeProvider
        ? "เปลี่ยนแปลงผู้ให้บริการ"
        : "เปลี่ยนแปลงนัดหมาย",
      status: params.status ?? appointment.status ?? 1,
      send_message: params.sendMessage !== false,
    },
  });

  // BookingSection ใช้ createdAppointment ปิดฟอร์มหลังทำรายการสำเร็จ
  if (result) {
    controller.setState({
      createdAppointment: { ...result, _created_at: moment().format() },
    });
  }
};

// ยกเลิกนัดหมาย: status 5 พร้อมเหตุผล (status_note)
export const HandleCancelPatientAppointment: Handler = async (controller, params) => {
  await PatchPatientAppointment(controller, {
    id: params.id,
    card: params.card,
    appointment: params.appointment,
    patient: params.patient,
    division: params.division,
    division_service_block: params.division_service_block,
    refreshDivision: params.refreshDivision,
    actionLabel: "ยกเลิกนัดหมาย",
    data: {
      status: 5,
      status_note: (params.note || "").trim() || "ยกเลิกโดยเจ้าหน้าที่",
      send_message: params.sendMessage !== false,
    },
  });
};

// ยืนยันนัดหมาย: status 2
// (main: HandleConfirmAppointment — MSG ไม่ต้องสร้าง chat channel เพราะ staff อยู่ในแชทแล้ว)
export const HandleConfirmPatientAppointment: Handler = async (controller, params) => {
  await PatchPatientAppointment(controller, {
    id: params.id,
    card: params.card,
    appointment: params.appointment,
    patient: params.patient,
    division: params.division,
    division_service_block: params.division_service_block,
    refreshDivision: params.refreshDivision,
    actionLabel: "ยืนยันนัดหมาย",
    data: {
      status: 2,
      ...(params.note ? { status_note: params.note } : {}),
      ...(params.sendMessage === true && { send_message: true }),
    },
  });
};

// ============================================================================
// Appointment Packages — logic ยกมาจาก ishealth-main (patient-lib/MobPackageInterface.ts)
// ปรับให้เข้ากับ state ของ MSG: ใช้ selectedPatientChat แทน patientData,
// ใช้ selectedDivision แทน selectedDivisionId
// ============================================================================

// ชำระแล้ว หรือรอชำระเงินหน้าเคาน์เตอร์ จึงนำไปใช้บริการ/นัดหมายได้
const isUsablePackageOrder = (item: any) =>
  item.status === "PAID" ||
  (item.custom_status === "BILLED_COUNTER" && item.status === "BILLED");

export const formatPackageItems = (items: any[]) =>
  items.map((item: any) => {
    const itemList = item.items || [];
    const totalUses = itemList.reduce(
      (sum: number, i: any) => sum + (parseFloat(i.quantity) || 0),
      0,
    );
    const remainingUses = itemList.reduce(
      (sum: number, i: any) => sum + (parseFloat(i.quantity_left) || 0),
      0,
    );

    return {
      ...item,
      price: parseFloat(item.price) || 0,
      remaining_uses: remainingUses,
      total_uses: totalUses,
    };
  });

// เติมรหัสประเภท (package / lab) สำหรับแสดง tag
const WithPackageTypeCode = async (controller: any, items: any[]) => {
  const state = controller.getState();
  let types: any[] = state.packageTypeList || [];

  if (!types.length) {
    const [result] = await PackageTypeList.list({
      apiToken: controller.apiToken,
      params: {},
    });
    types = result?.items || [];
    controller.setState({ packageTypeList: types });
  }

  return items.map((item: any) => ({
    ...item,
    package_type_code: types.find((type: any) => type.id === item.package_type)
      ?.code,
  }));
};

const GetPackageOrderItemsMsg = async (controller: any, params: any) => {
  const state = controller.getState();
  const patientId = params?.patient ?? state.selectedPatientChat?.id;

  // ไม่มีผู้ป่วย API จะคืน order ของทุกคน
  if (!patientId) {
    return [];
  }

  const apiParams: any = {
    statuses: params.statuses,
    patient: patientId,
    has_invoice: params.hasInvoice,
    exclude_expire_package_order: true,
    ...(params.usageStatus && { usage_status: params.usageStatus }),
    ...(params.inCart && { in_cart: true }),
    ...(params.excludeExceedQuantity && {
      exclude_package_order_with_exceed_quantity: true,
    }),
  };

  const [result] = await PackageOrderWithItemList.get({
    apiToken: controller.apiToken,
    params: apiParams,
  });

  return (result?.items || []).map((item: any) => ({
    ...item,
    price: parseFloat(item.price) || 0,
  }));
};

// แพ็กเกจของผู้รับบริการที่ผูกกับนัดหมายได้
export const GetAppointmentPackageOptions: Handler = async (controller) => {
  const items = await GetPackageOrderItemsMsg(controller, {
    statuses: ["PAID", "BILLED"],
    usageStatus: "INCOMPLETED",
    excludeExceedQuantity: true,
  });

  // รายการที่ซื้อล่าสุดอยู่บนสุด
  const usableItems = (items || [])
    .filter(isUsablePackageOrder)
    .sort((a: any, b: any) => moment(b.created_at).diff(moment(a.created_at)));

  return WithPackageTypeCode(controller, formatPackageItems(usableItems));
};

// แพ็กเกจ/รายการตรวจที่เปิดขาย ตามเงื่อนไขอายุ/เพศของผู้รับบริการ
let packageCatalogAbortController: AbortController | null = null;

export const GetAppointmentPackageCatalog: Handler = async (
  controller,
  params,
) => {
  const state = controller.getState();

  // ค้นใหม่ก่อน request เดิมจบ → ยกเลิกของเดิม (กันผลเก่าทับผลใหม่)
  packageCatalogAbortController?.abort();

  const abortController = new AbortController();
  packageCatalogAbortController = abortController;
  const patient = state.selectedPatientChat;
  const genders: Record<string, string> = { M: "MALE", F: "FEMALE" };
  const gender = genders[patient?.gender] || patient?.gender;

  const [result, errorBody, rawError] = await PackageWithItemList.get({
    apiToken: controller.apiToken,
    params: {
      ...(params?.keyword && { keyword: params.keyword }),
      active: true,
      of_division: state.selectedDivision?.id,
      ...(patient?.age && { age: patient.age }),
      ...(gender && { gender }),
    },
    extra: { signal: abortController.signal },
  });

  // ถูก abort เพราะมีการค้นใหม่ → คืน null ให้ UI ไม่เอาผลเก่าไปทับผลใหม่
  const isCanceled =
    rawError?.code === "ERR_CANCELED" || rawError?.name === "CanceledError";

  if (isCanceled || (!result && !errorBody)) {
    return null;
  }

  const packageList = (result?.items || []).map((item: any) => ({
    ...item,
    price: parseFloat(item.price_normal) || 0,
  }));

  return WithPackageTypeCode(controller, packageList);
};

// เพิ่มแพ็กเกจที่ยังไม่ได้ซื้อ เป็นรายการรอชำระเงินหน้าเคาน์เตอร์
export const HandleAddAppointmentPackage: Handler = async (
  controller,
  params,
) => {
  const state = controller.getState();
  // CartSection ไม่ได้เลือกสถานที่/แผนกเหมือน BookingSection → fallback ไป division ของแชท
  const division =
    params?.division ??
    state.selectedDivision?.id ??
    state.selectedPatientChat?.division ??
    controller.data?.division;

  const [order, orderError] = await PackageOrderList.create({
    apiToken: controller.apiToken,
    extra: { division },
    data: {
      patient: state.selectedPatientChat?.id,
      product: params.packageId,
      quantity: 1,
    },
  });

  if (orderError) {
    return { error: orderError };
  }

  const [, paymentError] = await PackageOrderCounterPaymentView.post({
    apiToken: controller.apiToken,
    extra: { division },
    data: { items: [order.id] },
  });

  return paymentError ? { error: paymentError } : { orderId: order.id };
};

// ============================================================================================
// CartSection (tab "Cart" ใน ProfilePanel) — display ตาม SearchResultSection ของ ishealth-main
//   MeHealthHome.tsx บรรทัด 742-750 (<SearchResultSection searchResults ... onAddClick={handleAddToCart} />)
//   + components/SearchResultSection.tsx (header "รายการตรวจทั้งหมด (n)" + row thumb/name/price/+)
//   + search flow ของ MeHealthHome: debounce 400ms → GetPackageList({ keyword }) →
//     dedup ด้วย id แล้วเรียง group specialDeal(0) → popular(1) → other(2) → display_seq → id
// ปรับเป็น staff flow: "ตะกร้า" = package order ของผู้รับบริการในแชทที่ยังไม่ชำระ
//   (custom_status IN_CART / BILLED_COUNTER / WAIT_CONFIRM_PAYMENT) staff เพิ่มรายการแทนได้
// ============================================================================================

export const CartPackageListCard = "GET_CART_PACKAGE_LIST";
// card ของ loadingStatus/errorMessage สำหรับปุ่ม "ส่งลิงก์ชำระเงิน" (StaffChat post เข้าแชท)
export const CartPaymentLinkCard = "GET_CART_PAYMENT_LINK";
// key loading/error ของแถว package ใน CartSection — ใช้ร่วมกันทั้ง เพิ่ม/ลด จำนวน
export const CartItemCard = (packageId: string | number) => `CART_PACKAGE_${packageId}`;

// พิมพ์ค้นรัว ๆ — request ก่อนหน้าต้องถูกยกเลิก กันผลเก่าทับผลใหม่
// (same pattern กับ packageCatalogAbortController ของ GetAppointmentPackageCatalog)
let cartListAbortController: AbortController | null = null;

// ─── cache สำหรับจูนความเร็วของ tab Cart ─────────────────────────────
// staff เปิด/ปิด tab ถี่ ๆ และกด + −รัว ๆ → ลดจำนวน request และไม่ต้องรอ API กว่าจะเห็นผล
// cartPackagePrefetch : รายการหน้าที่ "กำลังจะถึง" โหลดเก็บไว้ล่วงหน้า (background ไม่มี loading)
type CartPackagePrefetch = { keyword: string; offset: number; items: any[]; hasMore: boolean };
type CartPackagePage = { items: any[] | null; hasMore: boolean; errorBody?: any; rawError?: any };

const cartPackagePrefetch = new Map<string, CartPackagePrefetch>();
const cartPrefetchAbort = new Map<string, AbortController>();
// เลขลำดับการค้นของแต่ละคนไข้ — ผลเก่า (พิมพ์คำใหม่/สลับคนไข้) ทิ้งได้ กันผลทับกัน
const cartListSearchSeq = new Map<string, number>();
// mutation ของ package เดียวกันรันทีละตัว + นับจำนวนครั้งที่ค้างอยู่ (ดู ApplyCartOrder)
const cartMutationQueue = new Map<string, Promise<any>>();
const cartMutationPending = new Map<string, number>();

const cartPatientParams = (controller: any) => {
  const state = controller.getState();
  const patient = state.selectedPatientChat;
  const genders: Record<string, string> = { M: "MALE", F: "FEMALE" };
  const gender = genders[patient?.gender] || patient?.gender;

  // like GetAppointmentPackageCatalog: ขายเฉพาะของแผนกที่ staff ทำงานอยู่
  // และกรองตามอายุ/เพศของผู้รับบริการในแชท
  return {
    active: true,
    of_division: (state as any).selectedDivision?.id,
    ...(patient?.age && { age: patient.age }),
    ...(gender && { gender }),
  };
};

// quantity ของแพ็กเกจนับเป็น "จำนวนเต็ม" เท่านั้น (UI แสดง − n + เป็นเลขจำนวนเต็ม)
// API มักคืน string เช่น "2" / "2.00" → trunc ทิ้งส่วนเศษ และกัน 0/NaN ให้เป็น 1
export const toWholeQuantity = (value: any): number => {
  const quantity = parseInt(String(value ?? "").replace(/,/g, ""), 10);

  return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
};

const CartItemsCount = (items: any[]) =>
  (items || []).reduce((sum: number, item: any) => sum + toWholeQuantity(item.quantity), 0);

// จำนวน/รายการในตะกร้า — ใช้ GetPackageOrderItemsMsg (PackageOrderWithItemList.get) ของเดิมเลย
// params เดียวกับ GetPackageCartItemList ของ ishealth-main: statuses BILLED + in_cart true
// allowCache: cartData ของคนไข้นี้โหลดไว้แล้ว (เปิด tab ซ้ำ/นับ badge หลังค้น) = ใช้เลย 0 request
const GetCartPackageOrders = async (
  controller: any,
  patientId?: number,
  allowCache = false,
) => {
  if (allowCache) {
    const cached = CartItemsFromState(controller, patientId);

    if (cached) {
      return { items: cached, count: CartItemsCount(cached), cached: true };
    }
  }

  const items = await GetPackageOrderItemsMsg(controller, {
    statuses: "BILLED",
    inCart: true,
    patient: patientId,
  });

  // นับตาม quantity (กด + ซ้ำที่รายการเดิม = จำนวนเพิ่ม แต่ order เดียว)
  // ไม่งั้น badge จะค้างที่ 1 ทั้งที่ stepper แสดง 3 — MeHealthHome บรรทัด 253-263 ก็ reduce แบบนี้
  return { items, count: CartItemsCount(items), cached: false };
};

// แพ็กเกจที่เปิดขาย (keyword เปล่า =ทุกรายการของแผนก) — like GetPackageList ใน MeHealthHome
// แบ่งหน้า limit/offset แบบเดียวกับ ishealth-main (GetPackageItemList ใช้ result.next บอก hasMore)
export const CART_PACKAGE_LIST_LIMIT = 20;

// like GetHomePackageList: ราคาโชว์ใช้ price_normal (price_full = ราคาเต็มสำหรับขีดฆ่า)
const MapCartPackageItems = (items: any[]) =>
  (items || []).map((item: any) => ({
    ...item,
    price: parseFloat(item.price_normal ?? item.price) || 0,
    price_full: parseFloat(item.price_full ?? item.price_normal) || 0,
  }));

const FetchCartPackagePage = async (
  controller: any,
  keyword: string,
  offset: number,
  signal?: any,
): Promise<CartPackagePage> => {
  const [result, errorBody, rawError] = await PackageWithItemList.get({
    apiToken: controller.apiToken,
    params: {
      ...cartPatientParams(controller),
      ...(keyword && { keyword }),
      limit: CART_PACKAGE_LIST_LIMIT,
      ...(offset ? { offset } : {}),
    },
    ...(signal ? { extra: { signal } } : {}),
  });

  if (!result) {
    return { items: null, hasMore: false, errorBody, rawError };
  }

  return { items: MapCartPackageItems(result.items), hasMore: !!result.next, errorBody, rawError };
};

// โหลดหน้าถัดไปเก็บไว้เงียบ ๆ (background) — staff กด "โหลดรายการเพิ่ม" จะขึ้นทันทีไม่ต้องรอ API
// ผิดคำค้น/ผิดคนไข้/abort = seq ไม่ตรงทิ้งผลทิ้งทันที
const PrefetchCartPackagePage = (
  controller: any,
  patientId: number,
  keyword: string,
  offset: number,
) => {
  const patientKey = String(patientId);
  const seq = cartListSearchSeq.get(patientKey) ?? 0;
  const existing = cartPackagePrefetch.get(patientKey);

  if (existing && existing.keyword === keyword && existing.offset === offset) return;

  if (cartPackagePrefetch.size > 8) cartPackagePrefetch.clear();

  // เลื่อนไว้หลัง request ปัจจุบันจบ + render แล้ว (ไม่แข่ง bandwidth กันหน้าแรกช้า)
  setTimeout(() => {
    if ((cartListSearchSeq.get(patientKey) ?? 0) !== seq) return;

    const abortController = new AbortController();
    cartPrefetchAbort.get(patientKey)?.abort();
    cartPrefetchAbort.set(patientKey, abortController);

    FetchCartPackagePage(controller, keyword, offset, abortController.signal)
      .then((page) => {
        if (!page.items) return;
        if ((cartListSearchSeq.get(patientKey) ?? 0) !== seq) return;

        cartPackagePrefetch.set(patientKey, {
          keyword,
          offset,
          items: page.items,
          hasMore: page.hasMore,
        });
      })
      .catch(() => {});
  }, 400);
};

export const GetCartPackageList: Handler = async (controller, params) => {
  const state = controller.getState();
  const patientId = params?.patient ?? state.selectedPatientChat?.id;
  const keyword = (params?.keyword || "").trim();
  const offset = Math.max(0, parseInt(String(params?.offset ?? 0), 10) || 0);
  // โหลดหน้าถัดไปของ keyword เดิม → ต่อรายการท้ายลิสต์ ไม่เริ่มใหม่ทั้งลิสต์
  const isAppend = offset > 0;

  // ไม่มีผู้ป่วย API จะคืน order ของทุกคน (เหมือน GetPackageOrderItemsMsg)
  if (!patientId) {
    controller.setState({ cartData: {} } as any);
    patchLoadingStatus(controller, CartPackageListCard, false);
    return;
  }

  const patientKey = String(patientId);
  const cachedCartData = state.cartData || {};
  const cachedList: any[] = cachedCartData.packageList || [];
  const isSameSearch =
    cachedCartData.cartPatient === Number(patientId) &&
    (cachedCartData.searchKeyword ?? "") === keyword;

  // เปิด tab Cart กลับมาซ้ำด้วยคำค้นเดิมของคนไข้เดิม = cartData ชุดเดิมใช้ได้ (0 request)
  // ถ้าหน้าจอยังไม่หมด เก็บหน้าถัดไปไว้ล่วงหน้าให้กดโหลดเพิ่มติดทันที
  if (!isAppend && !params?.refresh && isSameSearch && cachedList.length) {
    if (cachedCartData.packageHasMore) {
      PrefetchCartPackagePage(controller, Number(patientId), keyword, cachedList.length);
    }

    return;
  }

  // การค้นใหม่ทำให้ prefetch เก่าใช้ไม่ได้ → abort + ลบทิ้ง
  if (!isAppend) {
    cartPrefetchAbort.get(patientKey)?.abort();
    cartPrefetchAbort.delete(patientKey);
    cartPackagePrefetch.delete(patientKey);
  }

  cartListAbortController?.abort();

  const abortController = new AbortController();
  cartListAbortController = abortController;
  const searchSeq = (cartListSearchSeq.get(patientKey) ?? 0) + 1;
  cartListSearchSeq.set(patientKey, searchSeq);

  patchLoadingStatus(controller, CartPackageListCard, true);
  patchErrorMessage(controller, CartPackageListCard, null);

  try {
    // กด "โหลดรายการเพิ่ม" ถ้า prefetch เก็บหน้านี้ไว้ตรง keyword/offset ใช้ cache = ไม่มี network delay
    const prefetched = cartPackagePrefetch.get(patientKey);
    const prefetchPage =
      isAppend && prefetched && prefetched.keyword === keyword && prefetched.offset === offset
        ? prefetched
        : null;

    const [page, cartOrders] = await Promise.all([
      prefetchPage
        ? Promise.resolve<CartPackagePage>({
            items: prefetchPage.items,
            hasMore: prefetchPage.hasMore,
          })
        : FetchCartPackagePage(controller, keyword, offset, abortController.signal),
      // โหลดหน้าเพิ่มไม่ต้องดึงตะกร้าซ้ำ (ตะกร้าไม่เปลี่ยนเพราะเลื่อนลิสต์)
      // และถ้าเพิ่ง GetCartPackageCount ไปแล้ว ใช้ cartItems ที่ cache ไว้ได้เลย (ลด GET ซ้ำตอนเปิด tab)
      isAppend
        ? Promise.resolve(null)
        : GetCartPackageOrders(controller, patientId, !params?.refresh),
    ]);

    if (prefetchPage) {
      cartPackagePrefetch.delete(patientKey);
    }

    const isCanceled =
      page.rawError?.code === "ERR_CANCELED" || page.rawError?.name === "CanceledError";

    // ถูก abort/แทนที่ด้วยการค้นใหม่ — ผลนี้เก่า อย่าเอาไปเขียน state
    if (
      isCanceled ||
      cartListAbortController !== abortController ||
      (cartListSearchSeq.get(patientKey) ?? 0) !== searchSeq
    ) {
      return;
    }

    if (!page.items) {
      console.error("[MSG][Cart] PackageWithItemList.get failed", page.errorBody ?? page.rawError);
      patchErrorMessage(controller, CartPackageListCard, "โหลดรายการตรวจไม่สำเร็จ");
      return;
    }

    const packageList = page.items;

    if (page.hasMore) {
      PrefetchCartPackagePage(controller, Number(patientId), keyword, offset + packageList.length);
    }

    controller.setState((prev: any) => {
      const prevCartData = prev.cartData || {};
      // คนละ keyword/คนละคนไข้ = ลิสต์ใหม่ ถ้าโหลดหน้าเพิ่มของเดิมค่อยต่อท้าย
      const canAppend =
        isAppend &&
        prevCartData.cartPatient === Number(patientId) &&
        (prevCartData.searchKeyword ?? "") === keyword;

      return {
        cartData: {
          ...prevCartData,
          packageList: canAppend
            ? [...(prevCartData.packageList || []), ...packageList]
            : packageList,
          // เก็บ keyword ที่ใช้โหลดลิสต์ไว้ ให้ UI กด "โหลดเพิ่ม" ด้วยคำเดิมได้ถูกหน้า
          searchKeyword: keyword,
          packageHasMore: page.hasMore,
          cartPatient: Number(patientId),
          ...(cartOrders
            ? {
                // badge = ผลรวม quantity ของรายการในตะกร้า (ดู toWholeQuantity)
                cartItems: cartOrders.items,
                cartCount: cartOrders.count,
              }
            : {}),
        },
      } as any;
    });
  } catch (e) {
    console.error("[MSG][Cart] GetCartPackageList failed", e);
    patchErrorMessage(controller, CartPackageListCard, "โหลดรายการตรวจไม่สำเร็จ");
  } finally {
    // อย่าล้าง loading ของ request ใหม่ ที่ถูกยิงทับภายหลัง (request เก่าถูก abort แล้ว)
    if (cartListAbortController === abortController) {
      patchLoadingStatus(controller, CartPackageListCard, false);
    }
  }
};

// โหลดเฉพาะจำนวนในตะกร้า (GetPackageOrderItemsMsg) — ใช้ตั้ง badgeCount ของ tab Cart
// (เรียกพร้อม GetPatientChatDetail ตอนเปิดแชท ไม่ต้องยิง catalog ไม่ต้องรอให้กด tab)
export const GetCartPackageCount: Handler = async (controller, params) => {
  const state = controller.getState();
  const patientId = params?.patient ?? state.selectedPatientChat?.id;

  if (!patientId) {
    return;
  }

  try {
    // cartData ชุดนี้โหลดไว้แล้ว (CartSection เพิ่งยิง GetCartPackageList ไป) = ใช้เลขเดิม 0 request
    const cart = await GetCartPackageOrders(controller, patientId, !params?.refresh);

    if (cart.cached) {
      return cart.count;
    }

    controller.setState((prev: any) => ({
      cartData: {
        ...(prev.cartData || {}),
        cartItems: cart.items,
        cartCount: cart.count,
        cartPatient: Number(patientId),
      },
    }) as any);

    return cart.count;
  } catch (e) {
    console.error("[MSG][Cart] GetCartPackageCount failed", e);
  }
};

// ─── ลิงก์ชำระเงิน (mehealthCheckout) สำหรับส่งเข้าแชทของลูกค้า ──────────────
// pattern เดียวกับ GetOAInvitationLink ของ ishealth-main:
//   OfficialAccountDivisionDetail.retrieve (header division) → result.id = oa id
//   https://liff.line.me/<liffId>?oa=<oa_id>&...
// ฝั่งลูกค้า MobIsHealth ตรวจ mehealthCheckout === "true" → push "/package-payment/" (ตะกร้า+ชำระเงิน)
const cartOaIdByDivision = new Map<string, number>();

const CartLiffBaseUrl = () => {
  const configured = (CONFIG as any).LINE_LIFF_URL || "";
  const liffId = CONFIG.MOBILE_LINE_LIFF_ID || "";

  // LINE_LIFF_URL มีค่าเต็ม https://liff.line.me/<liffId> อยู่แล้ว (config/base.json)
  if (configured) return configured;

  return liffId ? `https://liff.line.me/${liffId}` : "";
};

const GetCartOaId = async (controller: any, division: number | undefined) => {
  const cacheKey = String(division ?? "self");

  if (cartOaIdByDivision.has(cacheKey)) {
    return cartOaIdByDivision.get(cacheKey);
  }

  const [result] = await OfficialAccountDivisionDetail.retrieve({
    apiToken: controller.apiToken,
    ...(division ? { extra: { division } } : {}),
  });

  const oaId = Number(result?.id) || 0;

  if (oaId) cartOaIdByDivision.set(cacheKey, oaId);

  return oaId;
};

// สร้างข้อความ/ลิงก์สำหรับส่งเข้าแชท — StaffChat เป็นผู้ post เข้า chat channel เอง
// (controller ของ handler นี้คือ MainHISController ไม่มี chatController)
export const GetCartPaymentLink: Handler = async (controller, params) => {
  const card = CartPaymentLinkCard;
  const state = controller.getState();
  const patientId = params?.patient ?? state.selectedPatientChat?.id;

  if (!patientId) {
    patchErrorMessage(controller, card, "ไม่พบผู้รับบริการในแชทนี้");

    return null;
  }

  patchLoadingStatus(controller, card, true);
  patchErrorMessage(controller, card, null);

  try {
    const cart = await GetCartPackageOrders(controller, patientId, true);

    if (!cart.items.length) {
      patchErrorMessage(controller, card, "ยังไม่มีรายการในตะกร้าของผู้รับบริการ");

      return null;
    }

    const base = CartLiffBaseUrl();

    if (!base) {
      patchErrorMessage(controller, card, "ระบบยังไม่ได้ตั้งค่าลิงก์ LINE LIFF (LINE_LIFF_URL)");

      return null;
    }

    const oaId = await GetCartOaId(controller, CartDivisionId(controller, params));

    if (!oaId) {
      patchErrorMessage(controller, card, "ไม่พบข้อมูล LINE OA ของแผนกนี้");

      return null;
    }

    const link = `${base}?oa=${oaId}&mehealthCheckout=true`;
    // not use gendered particle — staff หลายแผนกส่งข้อความนี้แทนกัน
    const message = `กรุณาชำระเงินรายการตรวจที่คงอยู่ ${cart.count} รายการ ผ่านลิงก์ด้านล่างนี้\n${link}`;

    controller.setState({ cartPaymentLink: link } as any);

    return { link, message, cartCount: cart.count };
  } catch (e) {
    console.error("[MSG][Cart] GetCartPaymentLink failed", e);
    patchErrorMessage(controller, card, "สร้างลิงก์ชำระเงินไม่สำเร็จ กรุณาลองอีกครั้ง");

    return null;
  } finally {
    patchLoadingStatus(controller, card, false);
  }
};

// ─── เพิ่ม/ลดจำนวนในตะกร้า (UI แบบ  − จำนวน + ) ────────────────────────
// pattern เดียวกับฝั่ง ishealth-main (patient-lib/MobPackageInterface.ts)
//   ยังไม่มีในตะกร้า → PackageOrderList.create({ quantity: 1, add_to_cart: true })
//   มีอยู่แล้ว       → PackageOrderDetail.patch(pk: orderId, quantity: n + 1)
//   ลดเหลือ 0        → PackageOrderDetail.patch(pk: orderId, status: CANCELED)
// CartSection ไม่ได้เลือกแผนกเหมือน BookingSection → ใช้ division ของแชท
const CartDivisionId = (controller: any, params?: any) => {
  const state = controller.getState();

  return (
    params?.division ??
    state.selectedDivision?.id ??
    state.selectedPatientChat?.division ??
    controller.data?.division
  );
};

// order ของ package นี้ที่อยู่ในตะกร้า (1 package อาจมีหลาย order)
const FindCartOrdersOfPackage = (cartItems: any[], packageId: string | number) =>
  (cartItems || []).filter((item: any) => String(item.product) === String(packageId));

// อ่านตะกร้าจาก state ที่โหลดไว้แล้ว (GetCartPackageCount / GetCartPackageList)
// คืน null เมื่อยังไม่มีข้อมูลหรือเป็นของคนละคนไข้ → ค่อยยิง GET จริง
// ทำให้เพิ่ม/ลดจำนวน ใช้ GET แค่ครั้งเดียวหลัง mutate (ไม่ต้อง GET ก่อน + หลัง)
const CartItemsFromState = (controller: any, patientId: number | undefined) => {
  const cartData = controller.getState().cartData || {};

  if (!Array.isArray(cartData.cartItems)) {
    return null;
  }

  if (cartData.cartPatient && Number(cartData.cartPatient) !== Number(patientId)) {
    return null;
  }

  return cartData.cartItems as any[];
};

const CartMutationKey = (patientId: string | number, packageId: string | number) =>
  `${patientId}:${packageId}`;

// PATCH/POST ส่ง quantity แบบ absolute — ถ้า staff กดรัว ๆ แล้วสอง request วิ่งพร้อมกัน
// ตัวหลังจะทับตัวก่อน → เรียง mutation ของ package เดียวกันให้ทีละตัว (แสดงผลยังเป็น optimistic ทันที)
const RunCartMutation = (key: string, task: () => Promise<any>) => {
  const previous = cartMutationQueue.get(key) ?? Promise.resolve();
  const run = async () => {
    try {
      return await task();
    } catch (e) {
      return { error: e };
    }
  };

  const next = previous.then(run, run);
  cartMutationQueue.set(key, next);
  next.then(() => {
    if (cartMutationQueue.get(key) === next) cartMutationQueue.delete(key);
  });

  return next;
};

const CountCartPending = (key: string, delta: number) => {
  const pending = (cartMutationPending.get(key) || 0) + delta;

  if (pending > 0) cartMutationPending.set(key, pending);
  else cartMutationPending.delete(key);
};

const SetCartItemsState = (
  controller: any,
  patientId: string | number | undefined,
  items: any[],
) => {
  controller.setState((prev: any) => ({
    cartData: {
      ...(prev.cartData || {}),
      cartItems: items,
      cartCount: CartItemsCount(items),
      cartPatient: Number(patientId),
    },
  }) as any);

  return { items, count: CartItemsCount(items) };
};

// ปรับเลขใน cache ก่อน → stepper/badge เปลี่ยนทันทีไม่ต้องรอ round trip
// (ค่าจริงจาก response ของ API จะตามมาแก้ทีหลังใน ApplyCartOrder)
// คืน "แผน" ของการกดครั้งนี้ให้ mutation ใน queue ใช้ต่อ — ไม่งั้นกดรัว ๆ แล้ว task
// ที่รันทีหลังจะไปอ่าน cache ที่นำหน้าไปแล้ว มาคำนวณจำนวนซ้ำผิด (กด 2 ครั้ง = +3)
type CartMutationPlan = { order?: any; quantity?: number; cancel?: boolean };

const OptimisticCartQuantity = (
  controller: any,
  patientId: string | number | undefined,
  packageId: string | number,
  delta: number,
): CartMutationPlan | null => {
  const items = CartItemsFromState(controller, patientId);

  // ยังไม่เคยโหลดตะกร้าของคนไข้นี้เลย = ไม่รู้ว่าของจริงมี order ไหนบ้าง อย่าเดา
  if (!items) return null;

  const index = items.reduce((found: number, item: any, position: number) =>
    String(item.product) === String(packageId) ? position : found, -1,
  );

  // ยังไม่มีรายการนี้ในตะกร้า (ต้อง create order ใหม่) ให้ mutation จริงเป็นผู้ตัดสิน
  if (index < 0) return null;

  const order = items[index];
  const quantity = toWholeQuantity(order.quantity) + delta;
  const next = [...items];

  if (quantity >= 1) {
    next[index] = { ...order, quantity: String(quantity) };
    SetCartItemsState(controller, patientId, next);

    return { order, quantity };
  }

  // ลดจาก 1 = ยกเลิก order (ฝั่ง query ของตะกร้าก็จะไม่คืน order นี้)
  next.splice(index, 1);
  SetCartItemsState(controller, patientId, next);

  return { order, cancel: true };
};

// order ตัวที่การกดครั้งนี้วางไว้ ยังอยู่ในตะกร้าอยู่หรือเปล่า (task ก่อนหน้าอาจลบ/แก้ไปแล้ว)
const PickCartMutationTarget = (existingOrders: any[], plan: CartMutationPlan | null) => {
  if (plan?.order) {
    const planned = existingOrders.find((item: any) => String(item.id) === String(plan.order.id));

    if (planned) return planned;
  }

  return existingOrders[existingOrders.length - 1];
};

// PATCH/POST ตอบกลับเป็น serializer ของ order นั้นเอง (id, quantity, price, product_name, status)
// → เอามาตั้ง cartItems ได้เลย ไม่ต้อง GET ตามหลังทุกการกด (ของเดิม 1 กด = PATCH + GET)
const ApplyCartOrder = (
  controller: any,
  patientId: string | number | undefined,
  order: any,
  mutationKey: string,
) => {
  // API ไม่คืน object กลับมา (204 / แปลง format) → โหลดจริงกลับมาครั้งเดียวกันเลขคลาด
  if (!order || !order.id) {
    return RefreshCartData(controller, patientId);
  }

  const prevItems = CartItemsFromState(controller, patientId) || [];
  const index = prevItems.findIndex((item: any) => String(item.id) === String(order.id));
  const cachedItem = index >= 0 ? prevItems[index] : null;
  // มีการกดครั้งถัดไปใน queue ค้างอยู่ = ตัวเลขใน cache นำหน้า response นี้ อย่าเอาค่าเก่ามาทับ
  const outstanding = (cartMutationPending.get(mutationKey) || 0) - 1;

  const merged: any = {
    ...cachedItem,
    ...order,
    price: parseFloat(order.price ?? cachedItem?.price ?? 0) || 0,
  };

  if (outstanding > 0 && cachedItem) {
    merged.quantity = cachedItem.quantity;
  }

  const items = [...prevItems];

  if (merged.status === "CANCELED") {
    // query ของตะกร้า (statuses BILLED + in_cart) ไม่คืน order ที่ยกเลิกแล้ว
    if (index >= 0) items.splice(index, 1);
  } else if (index >= 0) {
    items[index] = merged;
  } else {
    items.push(merged);
  }

  return SetCartItemsState(controller, patientId, items);
};

// เขียน cartData ใหม่หลังเพิ่ม/ลด — ทั้ง cartItems (ตัว stepper) และ cartCount (badge)
const RefreshCartData = async (controller: any, patientId?: number) => {
  const targetPatientId = patientId ?? controller.getState().selectedPatientChat?.id;
  const cart = await GetCartPackageOrders(controller, targetPatientId);

  controller.setState((prev: any) => ({
    cartData: {
      ...(prev.cartData || {}),
      cartItems: cart.items,
      cartCount: cart.count,
      cartPatient: Number(targetPatientId),
    },
  }) as any);

  return cart;
};

// + = เพิ่มจำนวน (ถ้ายังไม่เคยมีในตะกร้าจะสร้าง order ใหม่)
export const HandleAddCartPackage: Handler = async (controller, params) => {
  const card = CartItemCard(params.packageId);
  const state = controller.getState();
  const patientId = params?.patient ?? state.selectedPatientChat?.id;
  const division = CartDivisionId(controller, params);

  if (!params.packageId) {
    patchErrorMessage(controller, card, "ไม่พบ id ของแพ็กเกจ");
    return;
  }

  if (!patientId) {
    patchErrorMessage(controller, card, "ไม่พบผู้รับบริการในแชทนี้");
    return;
  }

  const mutationKey = CartMutationKey(patientId, params.packageId);

  patchLoadingStatus(controller, card, true);
  patchErrorMessage(controller, card, null);

  // แสดงผลทันที (− 1 + / badge) แล้วค่อย reconcile กับ response ของ API
  const plan = OptimisticCartQuantity(controller, patientId, params.packageId, 1);
  CountCartPending(mutationKey, 1);

  try {
    return await RunCartMutation(mutationKey, async () => {
      const cachedCartItems = CartItemsFromState(controller, patientId);
      const existingOrders = FindCartOrdersOfPackage(
        cachedCartItems ?? (await GetCartPackageOrders(controller, patientId)).items,
        params.packageId,
      );

      if (existingOrders.length) {
        const target = PickCartMutationTarget(existingOrders, plan);
        // quantity = จำนวนเป้าหมายแบบ absolute (รวมการกดที่ค้างอยู่ใน queue แล้ว)
        const quantity = plan?.quantity ?? toWholeQuantity(target.quantity) + 1;

        const [order, patchError] = await PackageOrderDetail.patch({
          pk: target.id,
          apiToken: controller.apiToken,
          extra: { division },
          data: {
            quantity: String(quantity),
            product: params.packageId,
            add_to_cart: true,
          },
        });

        if (patchError) {
          patchErrorMessage(
            controller,
            card,
            extractApiErrorMessage(patchError) || "เพิ่มจำนวนไม่สำเร็จ กรุณาลองอีกครั้ง",
          );

          // order อาจถูกชำระเงิน/ลบจากหน้าอื่นไปแล้ว (cache stale) → โสดเลขจริงกลับมาทั้ง badge+stepper
          return await RefreshCartData(controller, patientId);
        }

        // 1 request ต่อ 1 การกด: ใช้ response ของ PATCH ตั้ง cartItems เลย
        return ApplyCartOrder(controller, patientId, order, mutationKey);
      }

      const [order, orderError] = await PackageOrderList.create({
        apiToken: controller.apiToken,
        extra: { division },
        data: {
          patient: patientId,
          product: params.packageId,
          quantity: 1,
          add_to_cart: true,
        },
      });

      if (orderError || !order) {
        patchErrorMessage(
          controller,
          card,
          extractApiErrorMessage(orderError) || "เพิ่มลงตะกร้าไม่สำเร็จ กรุณาลองอีกครั้ง",
        );

        return { error: orderError };
      }

      return ApplyCartOrder(controller, patientId, order, mutationKey);
    });
  } finally {
    CountCartPending(mutationKey, -1);
    patchLoadingStatus(controller, card, false);
  }
};

// − = ลดจำนวน (ของ package เดียวกันจะไล่ลบจาก order ล่าสุด ทีละชิ้น จนหมดก็ CANCELED order)
export const HandleDecreaseCartPackage: Handler = async (controller, params) => {
  const card = CartItemCard(params.packageId);
  const state = controller.getState();
  const patientId = params?.patient ?? state.selectedPatientChat?.id;
  const division = CartDivisionId(controller, params);

  if (!params.packageId) {
    patchErrorMessage(controller, card, "ไม่พบ id ของแพ็กเกจ");
    return;
  }

  if (!patientId) {
    patchErrorMessage(controller, card, "ไม่พบผู้รับบริการในแชทนี้");
    return;
  }

  const mutationKey = CartMutationKey(patientId, params.packageId);

  patchLoadingStatus(controller, card, true);
  patchErrorMessage(controller, card, null);

  const plan = OptimisticCartQuantity(controller, patientId, params.packageId, -1);
  CountCartPending(mutationKey, 1);

  try {
    return await RunCartMutation(mutationKey, async () => {
      const cachedCartItems = CartItemsFromState(controller, patientId);
      const existingOrders = FindCartOrdersOfPackage(
        cachedCartItems ?? (await GetCartPackageOrders(controller, patientId)).items,
        params.packageId,
      );

      // การกด − จนหมดทำให้ optimistic ลบ order ออกจาก cache ก่อนแล้ว → ใช้ order ที่ plan จำไว้
      // ไม่งั้นจะมองไม่เห็น order ตัวที่ต้อง cancel แล้วเด้งกลับไป 1 อีกครั้ง
      const target = plan?.order ?? PickCartMutationTarget(existingOrders, plan);

      // ไม่มี order ทั้งใน cache และใน plan = ไม่ได้ อยู่ในตะกร้าจริง (ชำระ/ลบจากหน้าอื่น)
      // ให้ badge กับ stepper ตรง server ใหม่
      if (!target) {
        return await RefreshCartData(controller, patientId);
      }
      const quantity = plan?.quantity ?? toWholeQuantity(target.quantity) - 1;

      const data =
        plan?.cancel || quantity <= 0
          ? { status: "CANCELED", product: params.packageId, remark: "ลบแพ็กเกจ" }
          : { quantity: String(quantity), product: params.packageId, add_to_cart: true };

      const [order, patchError] = await PackageOrderDetail.patch({
        pk: target.id,
        apiToken: controller.apiToken,
        extra: { division },
        data,
      });

      if (patchError) {
        patchErrorMessage(
          controller,
          card,
          extractApiErrorMessage(patchError) || "ลดจำนวนไม่สำเร็จ กรุณาลองอีกครั้ง",
        );

        return await RefreshCartData(controller, patientId);
      }

      // CANCELED ใน response = ลบรายการออกจาก cartItems (ApplyCartOrder จัดการให้)
      return ApplyCartOrder(controller, patientId, order, mutationKey);
    });
  } finally {
    CountCartPending(mutationKey, -1);
    patchLoadingStatus(controller, card, false);
  }
};
